import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K]
}
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>
}
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>
}
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T
> = { [_ in K]?: never }
export type Incremental<T> =
  | T
  | {
    [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never
  }
const defaultOptions = {} as const
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: any; output: any }
  /** An RFC 3986 and RFC 3987 compliant URI string. */
  URL: { input: any; output: any }
}

/** Represents information about personal information. */
export type Address = {
  __typename?: 'Address'
  /** The first line of the address. Typically the street address or PO Box number. */
  address1: Scalars['String']['output']
  /** The second line of the address. Typically the number of the apartment, suite, or unit. */
  address2?: Maybe<Scalars['String']['output']>
  /** The name of the city, district, village, or town. */
  city: Scalars['String']['output']
  /** The name of the country. */
  country?: Maybe<Scalars['String']['output']>
  /** The three-letter code for the country of the address. For example, JPN. */
  countryCode?: Maybe<CountryCode>
  /** The region of the address, such as the province, state, prefecture, or district. */
  prefecture?: Maybe<Scalars['String']['output']>
  /** The two-letter code for the region. For example, HK. */
  prefectureCode?: Maybe<PrefectureCode>
  /** The zip or postal code of the address. */
  zip: Scalars['String']['output']
}

/** Provides personal information fields and values to use when creating a customer. */
export type AddressInfoUpdateInput = {
  /** The customer's address1. */
  address1?: InputMaybe<Scalars['String']['input']>
  /** The customer's address2. */
  address2?: InputMaybe<Scalars['String']['input']>
  /** The customer's city. */
  city?: InputMaybe<Scalars['String']['input']>
  /** The customer's country_code. */
  countryCode?: InputMaybe<CountryCode>
  /** The customer's prefecture_code. */
  prefectureCode?: InputMaybe<PrefectureCode>
  /** The customer's zip. */
  zip?: InputMaybe<Scalars['String']['input']>
}

/** 適用されているディスカウントリスト */
export type AppliedDiscount = {
  __typename?: 'AppliedDiscount'
  discounts?: Maybe<DiscountConnection>
}

/** 適用されているディスカウントリスト */
export type AppliedDiscountDiscountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  canOverlap?: InputMaybe<Scalars['Boolean']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  customerSelection?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  product?: InputMaybe<Scalars['ID']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  usageLimit?: InputMaybe<Scalars['Int']['input']>
}

/**
 * SAGAアリーナのみバリエーション毎に日付とQuantityを管理する必要があるため、
 * 予約作成時に入力されたバリエーション毎の利用日とQuantityを管理する。
 *
 * 例) SAGAアリーナのでは以下のようにOrderLineItemを管理する必要がある
 * 予約日時:
 * 1/1 ~ 1/3
 *
 * 予約対象:
 * - メインアリーナ 設営・撤去
 *     - Quantity: 3
 *     - dateOfUse: 1/1
 * - メインアリーナ 催事
 *     - Quantity: 1
 *     - dateOfUse: 1/2
 * - メインアリーナ 設営・撤去
 *     - Quantity: 4
 *     - dateOfUse: 1/3
 */
export type ArenaBookingInfo = Node & {
  __typename?: 'ArenaBookingInfo'
  /** 予約したバリエーションを実際に使用する日付 */
  dateOfUse: Scalars['Date']['output']
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** 予約時間 */
  quantity: Scalars['Int']['output']
}

/**
 * SAGAアリーナのみバリエーション毎に日付とQuantityを管理する必要があるため、
 * 予約作成時に入力されたバリエーション毎の利用日とQuantityを管理する。
 *
 * 例) SAGAアリーナのでは以下のようにOrderLineItemを管理する必要がある
 * 予約日時:
 * 1/1 ~ 1/3
 *
 * 予約対象:
 * - メインアリーナ 設営・撤去
 *     - Quantity: 3
 *     - dateOfUse: 1/1
 * - メインアリーナ 催事
 *     - Quantity: 1
 *     - dateOfUse: 1/2
 * - メインアリーナ 設営・撤去
 *     - Quantity: 4
 *     - dateOfUse: 1/3
 */
export type ArenaBookingInfoInput = {
  /** 予約したバリエーションを実際に使用する日付 */
  dateOfUse: Scalars['Date']['input']
  /** 予約時間 */
  quantity?: Scalars['Int']['input']
}

/** The availability status */
export enum Availabilities {
  /** 空きに余裕があります。 */
  Available = 'AVAILABLE',
  /** お問い合わせください。 */
  ContactRequired = 'CONTACT_REQUIRED',
  /** 空きに限りがあります。 */
  Limited = 'LIMITED',
  /** 空きがありません。 */
  Unavailable = 'UNAVAILABLE',
}

/** Input to narrow down the available products. */
export type AvailableProductsInput = {
  /** Scheduled end date. */
  end?: InputMaybe<Scalars['Date']['input']>
  /** Specify the rate id for variants not for sale. */
  rateVariantId?: InputMaybe<Scalars['ID']['input']>
  /** Scheduled start date. */
  start?: InputMaybe<Scalars['Date']['input']>
}

/** Input required to get booking availabilities. */
export type BookingAvailabilitiesListInput = {
  /** Date of interest. */
  date: Scalars['Date']['input']
  /** This product's id. */
  productId: Scalars['ID']['input']
}

/** Availability of booking for each date. */
export type BookingAvailability = {
  __typename?: 'BookingAvailability'
  /** The availability status. */
  availability?: Maybe<Availabilities>
  /** Date of interest. */
  date?: Maybe<Scalars['Date']['output']>
}

/** Represents a list of reservation dates and their data. */
export type BookingDate = Node & {
  __typename?: 'BookingDate'
  /** Time of check-in. */
  checkedInAt?: Maybe<Scalars['Time']['output']>
  /** Time of check-out. */
  checkedOutAt?: Maybe<Scalars['Time']['output']>
  /** Start date for a particular element. */
  date: Scalars['Date']['output']
  /** Time that exceeded. */
  exceededTime?: Maybe<Scalars['Time']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
}

/** The order bookingDate information. */
export type BookingDateInput = {
  /** The order's end date. */
  end: Scalars['Date']['input']
  /** The order's start date. */
  start: Scalars['Date']['input']
}

/** Simple reservation status confirmation list. */
export type BookingStatusList = {
  __typename?: 'BookingStatusList'
  /** This product's id. */
  productId?: Maybe<Scalars['ID']['output']>
  /** The product's name. */
  productName?: Maybe<Scalars['String']['output']>
  /** The product's variant. */
  productVariants?: Maybe<Array<Maybe<ProductVariants>>>
}

/** Arguments for calling BookingStatusList. */
export type BookingStatusListInput = {
  /** The Date data. */
  date?: InputMaybe<Scalars['Date']['input']>
  /** ID of the order to be excluded from query. */
  excludeOrderId?: InputMaybe<Scalars['ID']['input']>
  /** The product's id. */
  productId: Scalars['ID']['input']
}

/** Simple booking status confirmation list. */
export type BookingStatusOfTheDay = {
  __typename?: 'BookingStatusOfTheDay'
  /** The Date data. */
  date?: Maybe<Scalars['Date']['output']>
  /** The product's information. */
  products?: Maybe<Array<BookingStatusOfTheDayProducts>>
}

/** Arguments for calling BookingStatusOfTheDay. */
export type BookingStatusOfTheDayInput = {
  /** The Date data. */
  date?: InputMaybe<Scalars['Date']['input']>
}

/** Variants information for product. */
export type BookingStatusOfTheDayProductVariants = {
  __typename?: 'BookingStatusOfTheDayProductVariants'
  /** The product's variant available for sale. */
  availableForSale: Scalars['Boolean']['output']
  /** The reservation status from 9:00 to 21:00 is represented by '' and '[order id]', '' is a blank and [order id] is a have check mark (✔). */
  bookings: Array<Scalars['ID']['output']>
  /** This object's id. */
  id: Scalars['ID']['output']
  /** The product's variant name. */
  name: Scalars['String']['output']
}

/** The product's information. */
export type BookingStatusOfTheDayProducts = {
  __typename?: 'BookingStatusOfTheDayProducts'
  /** This product's id. */
  id: Scalars['ID']['output']
  /** The product's name. */
  name: Scalars['String']['output']
  /** The product's variant. */
  variants?: Maybe<Array<BookingStatusOfTheDayProductVariants>>
}

/** Simple booking status confirmation month list. */
export type BookingStatusOfTheMonth = {
  __typename?: 'BookingStatusOfTheMonth'
  /** The Date data. */
  date?: Maybe<Scalars['Date']['output']>
  /** The product's information. */
  products?: Maybe<Array<BookingStatusOfTheMonthProducts>>
}

/** Variants information for product. */
export type BookingStatusOfTheMonthProductVariants = {
  __typename?: 'BookingStatusOfTheMonthProductVariants'
  /** The product's variant available for sale. */
  availableForSale: Scalars['Boolean']['output']
  /** List of Booking dates in variant for given month */
  bookingDates: Array<Maybe<Scalars['Date']['output']>>
  /** This object's id. */
  id: Scalars['ID']['output']
  /** The product's variant name. */
  name: Scalars['String']['output']
}

/** The product's information. */
export type BookingStatusOfTheMonthProducts = {
  __typename?: 'BookingStatusOfTheMonthProducts'
  /** This product's id. */
  id: Scalars['ID']['output']
  /** The product's name. */
  name: Scalars['String']['output']
  /** The product's variant. */
  variants?: Maybe<Array<BookingStatusOfTheMonthProductVariants>>
}

/** Information about the order calendar. */
export type Calendar = {
  __typename?: 'Calendar'
  /** Whether the user agrees to have their order published online. */
  approval: Scalars['Boolean']['output']
  /**
   * Name of the event.
   * (eventName)
   */
  eventName?: Maybe<Scalars['String']['output']>
  /** Organizer of the event. */
  organizer?: Maybe<Scalars['String']['output']>
  /**
   * Date the user wishes the order to be published.
   * (publishableDate)
   */
  publishableDate?: Maybe<Scalars['DateTime']['output']>
}

/** The order calendar information. */
export type CalendarInput = {
  /** Whether the customer wishes to have their event published online. */
  approval?: InputMaybe<Scalars['Boolean']['input']>
  /** Name of the event. */
  eventName?: InputMaybe<Scalars['String']['input']>
  /** Name of the event organizer. */
  organizer?: InputMaybe<Scalars['String']['input']>
  /** Date the event can be published online. */
  publishableDate?: InputMaybe<Scalars['Date']['input']>
}

/**
 * Represents information about the contact form which will be returned to the user.
 * All fields except 'created_at' and 'id' can be queried.
 */
export type ContactForm = {
  __typename?: 'ContactForm'
  /** Customer's email address */
  email: Scalars['String']['output']
  /** The actual query. */
  message: Scalars['String']['output']
  /** Customer's name */
  name: Scalars['String']['output']
  /**
   * Type of query.
   * (queryType)
   */
  queryType: Scalars['String']['output']
  /**
   * Reference number of query.
   * (refNumber)
   */
  refNumber: Scalars['String']['output']
  /** Subject of query. */
  subject: Scalars['String']['output']
}

/**
 * Possible error codes that could be returned by ContactFormError.
 * TODO: Mutation 実装時に適宜追加
 */
export enum ContactFormErrorCode {
  /** Input value is blank. */
  Blank = 'BLANK',
  /** Input value is invalid. */
  Invalid = 'INVALID',
  /** Failed to send email. */
  MailSendingError = 'MAIL_SENDING_ERROR',
  /** Contact form does not exist. */
  NotFound = 'NOT_FOUND',
  /** Input value is too long. */
  TooLong = 'TOO_LONG',
  /** Input value is too short. */
  TooShort = 'TOO_SHORT',
}

/**
 * Input information when the customer submits the contact form.
 * All fields are required.
 */
export type ContactFormInput = {
  /** Email address of user. */
  email: Scalars['String']['input']
  /** Query message submitted by the user. */
  message: Scalars['String']['input']
  /** Name of user. */
  name: Scalars['String']['input']
  /** Type of query. */
  queryType: ContactFormQueryType
  /** Subject of query. */
  subject: Scalars['String']['input']
}

/** Query types available on the contact form. */
export enum ContactFormQueryType {
  Other = 'OTHER',
}

/** Saves the content of the contact form submitted by the user. */
export type ContactFormSubmit = {
  __typename?: 'ContactFormSubmit'
  /** Submitted contact form. */
  contactForm?: Maybe<ContactForm>
  /** List of errors that occurred executing the mutation. */
  contactFormUserErrors: Array<ContactFormUserError>
}

/** Represents an error that happens during execution of a order mutation. */
export type ContactFormUserError = DisplayableError & {
  __typename?: 'ContactFormUserError'
  /** Error code to uniquely identify the error. */
  code?: Maybe<ContactFormErrorCode>
  /** Path to the input field which caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>
  /** The error message. */
  message: Scalars['String']['output']
}

export type ContactOfRepresentativeInput = {
  /** Customer's email address. */
  email?: InputMaybe<Scalars['String']['input']>
  /** Name of customer representing the group. */
  name?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

/**
 * The three-letter code for the country of the address.
 *     For example, JPN.
 */
export enum CountryCode {
  /** Japan */
  Jpn = 'JPN',
}

/** Represents information about customers such as personal information. */
export type Customer = Node & {
  __typename?: 'Customer'
  /** Represents information about personal information. */
  address?: Maybe<Address>
  appliedDiscount?: Maybe<AppliedDiscount>
  /**
   * The account ID generated by Auth0.
   * (auth0Id)
   */
  auth0Id?: Maybe<Scalars['String']['output']>
  /**
   * 新規登録後に審査され、予約可能な顧客が判別するためのフラグ
   * (bookableFlag)
   */
  bookableFlag: Scalars['Boolean']['output']
  /**
   * The customer corporation's name.
   * (corporationName)
   */
  corporationName?: Maybe<Scalars['String']['output']>
  /**
   * The customer corporation's name kana.
   * (corporationNameKana)
   */
  corporationNameKana?: Maybe<Scalars['String']['output']>
  /**
   * Date and time when the customer was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** The customer's email address. */
  email?: Maybe<Scalars['String']['output']>
  /**
   * The customer's first name.
   * (firstName)
   */
  firstName: Scalars['String']['output']
  /** The customer's full name. */
  fullname?: Maybe<Scalars['String']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /**
   * Whether the customer is active.
   * (isActive)
   */
  isActive: Scalars['Boolean']['output']
  /**
   * The customer's last name.
   * (lastName)
   */
  lastName: Scalars['String']['output']
  /** 顧客メタ情報 */
  metaFields?: Maybe<MetaFieldConnection>
  /** The customer's remarks. */
  note?: Maybe<Scalars['String']['output']>
  /** The customer's phone number. */
  phone?: Maybe<Scalars['String']['output']>
  /** The customer's tag list */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** The customer's type. */
  type: CustomerType
  /**
   * Date and time when the customer was last modified.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
  /** Indicates information related to incidental information. */
  userMetaData?: Maybe<UserMetaData>
}

/** Represents information about customers such as personal information. */
export type CustomerMetaFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  nameSpace?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['Boolean']['input']>
  valueType?: InputMaybe<Scalars['String']['input']>
}

/** Possible error codes that could be returned by CustomerError. */
export enum CustomerErrorCode {
  /** Auth0 user did not have an email address matching */
  Auth0EmailNotFound = 'AUTH0_EMAIL_NOT_FOUND',
  /** Object didn't pass validation for format user-id */
  Auth0InvalidUrl = 'AUTH0_INVALID_URL',
  /** Payload validation error: 'Expected type string but found type null' on property email (The user's email). */
  Auth0UsersEmailIsNull = 'AUTH0_USERS_EMAIL_IS_NULL',
  /** The user already exists. */
  Auth0UserAlreadyExits = 'AUTH0_USER_ALREADY_EXITS',
  /** Input email contains an invalid domain name. */
  BadDomain = 'BAD_DOMAIN',
  /** Input value is blank. */
  Blank = 'BLANK',
  /** Input contains HTML tags. */
  ContainsHtmlTags = 'CONTAINS_HTML_TAGS',
  /** Input contains URL. */
  ContainsUrl = 'CONTAINS_URL',
  /** Customer is disabled. */
  CustomerDisabled = 'CUSTOMER_DISABLED',
  /** Duplicate data exists. */
  DuplicateDataExists = 'DUPLICATE_DATA_EXISTS',
  /** Input value is invalid. */
  Invalid = 'INVALID',
  /** Customer does not exist. */
  NotFound = 'NOT_FOUND',
  /** PasswordStrengthError: Password is too weak */
  PasswordTooWeak = 'PASSWORD_TOO_WEAK',
  /** Input value is already taken. */
  Taken = 'TAKEN',
  /** Invalid activation token. */
  TokenInvalid = 'TOKEN_INVALID',
  /** Input value is too long. */
  TooLong = 'TOO_LONG',
  /** Input value is too short. */
  TooShort = 'TOO_SHORT',
  /** Unidentified organization. */
  UndefinedCustomer = 'UNDEFINED_CUSTOMER',
}

/** The customer type */
export enum CustomerType {
  /** 法人 */
  Corporate = 'CORPORATE',
  /** 個人 */
  Personal = 'PERSONAL',
  /** 顧客タイプ未登録 */
  Unregistered = 'UNREGISTERED',
}

/** update a customer. */
export type CustomerUpdate = {
  __typename?: 'CustomerUpdate'
  /** The updated customer. */
  customer?: Maybe<Customer>
  /** List of errors that occurred executing the mutation. */
  customerUserErrors: Array<CustomerUserError>
}

/** Provides the fields and values to use when creating customer. */
export type CustomerUpdateInput = {
  /** The customer's address information. */
  address?: InputMaybe<AddressInfoUpdateInput>
  /** 新規登録後に審査され、予約可能な顧客が判別するためのフラグ */
  bookableFlag?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's corporation name. */
  corporationName?: InputMaybe<Scalars['String']['input']>
  /** The customer's corporation name kana. */
  corporationNameKana?: InputMaybe<Scalars['String']['input']>
  /** 対象施設が選択されているディスカウント */
  discountWithTargetProducts?: InputMaybe<
    Array<InputMaybe<Scalars['ID']['input']>>
  >
  /** The unique email of the customer. */
  email?: InputMaybe<Scalars['String']['input']>
  /** The customer's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>
  /** The customer's active flg. */
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's last name. */
  lastName?: InputMaybe<Scalars['String']['input']>
  /** The customer's remarks. */
  note?: InputMaybe<Scalars['String']['input']>
  /** The customer's phone. */
  phone?: InputMaybe<Scalars['String']['input']>
  /** This is a flag to determine whether it is a prefectural organization. */
  prefecturalGroupFlag?: InputMaybe<Scalars['Boolean']['input']>
  /** ストア全体に適用されるディスカウント */
  storeWideDiscount?: InputMaybe<Scalars['ID']['input']>
  /** Whether the sub arena can be reserved. */
  subArenaBookableFlag?: InputMaybe<Scalars['Boolean']['input']>
  /** The customer's tag list. */
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  /** The customer's type. */
  type?: InputMaybe<CustomerType>
  /** The customer's ancillary information. */
  userMetaData?: InputMaybe<UserMetaDataInfoUpdateInput>
}

/** Represents an error that happens during execution of a customer mutation. */
export type CustomerUserError = DisplayableError & {
  __typename?: 'CustomerUserError'
  /** Error code to uniquely identify the error. */
  code?: Maybe<CustomerErrorCode>
  /** Path to the input field which caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>
  /** The error message. */
  message: Scalars['String']['output']
}

/** Name and reservation information for the day. */
export type DataOfTheDays = {
  __typename?: 'DataOfTheDays'
  /** The booking info. */
  bookings?: Maybe<Array<Maybe<Scalars['Int']['output']>>>
  /** The date string. */
  name?: Maybe<Scalars['String']['output']>
}

/** Represents information about Holiday Dates. */
export type Dates = {
  __typename?: 'Dates'
  /** Regularly scheduled monthly dates for holidays. */
  date?: Maybe<Scalars['Int']['output']>
}

/** Represents information about DaysOfWeek. */
export type DaysOfWeek = {
  __typename?: 'DaysOfWeek'
  /** Days of the week name when the closed. */
  name?: Maybe<Scalars['String']['output']>
  /** Number of days of the week, with Monday being 1. */
  nth?: Maybe<Scalars['Int']['output']>
}

/** ディスカウントオブジェクト */
export type Discount = Node & {
  __typename?: 'Discount'
  /**
   * 他のディスカウントとの重複可否
   * (canOverlap)
   */
  canOverlap?: Maybe<Scalars['Boolean']['output']>
  /**
   * 作成日時
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /**
   * ディスカウントを使用可能なカスタマー
   * (customerSelection)
   */
  customerSelection?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** 説明 */
  description?: Maybe<Scalars['String']['output']>
  /** 割引率 */
  discountPercent?: Maybe<DiscountPercent>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Information about the product. */
  product?: Maybe<Product>
  /** The payment status. */
  status: Scalars['String']['output']
  /** タイトル */
  title: Scalars['String']['output']
  /**
   * 更新日時
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
  /**
   * 毎月の最大使用可能回数
   * (usageLimit)
   */
  usageLimit: Scalars['Int']['output']
}

export type DiscountConnection = {
  __typename?: 'DiscountConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<DiscountEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `Discount` and its cursor. */
export type DiscountEdge = {
  __typename?: 'DiscountEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<Discount>
}

/** 手入力割引の情報 */
export type DiscountFee = {
  __typename?: 'DiscountFee'
  /** Reason for discount fee. */
  reason: Scalars['String']['output']
  /** The discount amount. */
  value: Scalars['Float']['output']
}

/** 手入力で施設利用料金が割り引く場合の詳細 */
export type DiscountFeeInput = {
  /** 割り引いた理由 */
  reason: Scalars['String']['input']
  /** 割引金額 */
  value: Scalars['Float']['input']
}

export type DiscountPercent = {
  __typename?: 'DiscountPercent'
  /** 割引率の分母 */
  denominator: Scalars['Int']['output']
  /** 割引率のラベル */
  discountPercentLabel: DiscountPercentLabel
  /** 割引率の分子 */
  numerator: Scalars['Int']['output']
}

/** The discount percent. */
export enum DiscountPercentLabel {
  /** 全額減免 */
  Full = 'FULL',
  /** 1/2減免 */
  OneHalf = 'ONE_HALF',
  /** 2/3減免 */
  TwoThird = 'TWO_THIRD',
}

/** Represents an error in the input of a mutation. */
export type DisplayableError = {
  /** Path to the input field which caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>
  /** The error message. */
  message: Scalars['String']['output']
}

/** Information about the order extension fee. */
export type ExtensionFee = Node & {
  __typename?: 'ExtensionFee'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Reason for exceed fee. */
  reason: Scalars['String']['output']
  /** The excess amount. */
  value: Scalars['Float']['output']
}

/** The order extension fee information. */
export type ExtensionFeeInput = {
  /** The extension fee reason. */
  reason: Scalars['String']['input']
  /** The extension fee value. */
  value: Scalars['Float']['input']
}

/** Model of the failed response from auth0 management API verification_email. */
export type FailedVerifyMailResponse = {
  /** The HTTP response code from requesting Auth0 management API verification_email. */
  code?: Maybe<Scalars['String']['output']>
}

/** Represents information about building is closed and natural holidays. */
export type Holiday = Node & {
  __typename?: 'Holiday'
  holidays?: Maybe<HolidaysConnection>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Year of the holiday . */
  year: Scalars['Int']['output']
}

/** Represents information about building is closed and natural holidays. */
export type HolidayHolidaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTime']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  isAutoGenerated?: InputMaybe<Scalars['Boolean']['input']>
  isClose?: InputMaybe<Scalars['Boolean']['input']>
  isPublic?: InputMaybe<Scalars['Boolean']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}

export type HolidayConnection = {
  __typename?: 'HolidayConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HolidayEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `Holiday` and its cursor. */
export type HolidayEdge = {
  __typename?: 'HolidayEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<Holiday>
}

/** Represents building is closed and natural holidays information. */
export type Holidays = Node & {
  __typename?: 'Holidays'
  /** A target date. */
  date: Scalars['DateTime']['output']
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /**
   * Whether automatically generated by batch
   * (isAutoGenerated)
   */
  isAutoGenerated: Scalars['Boolean']['output']
  /**
   * Whether a store holiday.
   * (isClose)
   */
  isClose: Scalars['Boolean']['output']
  /**
   * Whether a public holiday.
   * (isPublic)
   */
  isPublic: Scalars['Boolean']['output']
  /** Represents multilingual product name. */
  reason?: Maybe<I18nString>
}

export type HolidaysConnection = {
  __typename?: 'HolidaysConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HolidaysEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
}

/** A Relay edge containing a `Holidays` and its cursor. */
export type HolidaysEdge = {
  __typename?: 'HolidaysEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<Holidays>
}

/** Represents a multilingual character string. */
export type I18nString = {
  __typename?: 'I18nString'
  /** The english string value. */
  enUs?: Maybe<Scalars['String']['output']>
  /** The japanese string value. */
  jaJp: Scalars['String']['output']
  /** The korean string value. */
  koKr?: Maybe<Scalars['String']['output']>
  /** The chinese string value. */
  zhCn?: Maybe<Scalars['String']['output']>
  /** The taiwan string value. */
  zhTw?: Maybe<Scalars['String']['output']>
}

/** Represents an image resource. */
export type Image = Node & {
  __typename?: 'Image'
  Cls?: Maybe<Scalars['String']['output']>
  /**
   * A word or phrase to share the nature or contents of an file.
   * (altText)
   */
  altText?: Maybe<Scalars['String']['output']>
  /** The file encoding. */
  encoding?: Maybe<Scalars['String']['output']>
  /** The human friendly file name. */
  filename: Scalars['String']['output']
  /** The file path. */
  filepath?: Maybe<Scalars['String']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The unique actual file name on storage. */
  key: Scalars['String']['output']
  /**
   * The mime type of uploaded file
   * (mimeType)
   */
  mimeType: Scalars['String']['output']
  /** The size of file. */
  size?: Maybe<Scalars['Int']['output']>
  /** The location of the image as a URL. */
  src: Scalars['URL']['output']
}

/** The Language Code */
export enum LanguageCode {
  /** en_us */
  EnUs = 'EN_US',
  /** ja_jp */
  JaJp = 'JA_JP',
  /** ko_kr */
  KoKr = 'KO_KR',
  /** zh_cn */
  ZhCn = 'ZH_CN',
  /** zh_tw */
  ZhTw = 'ZH_TW',
}

/** クリッカブルマップの座標 */
export type MapPosition = Node & {
  __typename?: 'MapPosition'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** 緯度 */
  lat: Scalars['Int']['output']
  /** 経度 */
  lng: Scalars['Int']['output']
}

/** Represents object for the member model. */
export type Member = Node & {
  __typename?: 'Member'
  /**
   * The account ID generated by Auth0.
   * (auth0Id)
   */
  auth0Id?: Maybe<Scalars['String']['output']>
  /**
   * The member's avatar image URL.
   * (avatarUrl)
   */
  avatarUrl?: Maybe<Scalars['String']['output']>
  /**
   * Date and time when the member was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** The member's email address. */
  email: Scalars['String']['output']
  /**
   * The member's first name.
   * (firstName)
   */
  firstName: Scalars['String']['output']
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /**
   * Whether the member has verified their email address.
   * (isActive)
   */
  isActive: Scalars['Boolean']['output']
  /**
   * The member's last name.
   * (lastName)
   */
  lastName: Scalars['String']['output']
  /**
   * Date and time when the member was last modified.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
}

/** 顧客メタ情報 */
export type MetaField = Node & {
  __typename?: 'MetaField'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  key: Scalars['String']['output']
  nameSpace: Scalars['String']['output']
  value: Scalars['Boolean']['output']
  valueType: Scalars['String']['output']
}

export type MetaFieldConnection = {
  __typename?: 'MetaFieldConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MetaFieldEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `MetaField` and its cursor. */
export type MetaFieldEdge = {
  __typename?: 'MetaFieldEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<MetaField>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type Mutation = {
  __typename?: 'Mutation'
  /** Saves the content of the contact form submitted by the user. */
  contactFormSubmit?: Maybe<ContactFormSubmit>
  /** update a customer. */
  customerUpdate?: Maybe<CustomerUpdate>
  orderCancel?: Maybe<OrderCancel>
  orderCreate?: Maybe<OrderCreate>
  /** Updates an exiting order. */
  orderUpdate?: Maybe<OrderUpdate>
  /** Mutation to calculate all price fields */
  priceCalculate?: Maybe<PriceCalculate>
  /** Export a invoice. */
  reportInvoiceExport?: Maybe<ReportInvoiceExport>
  /**
   * Send customize verification mail, calling Auth0 management API jobs verification_email,
   * then send the verification email to specific user whose authID is sent.
   */
  userVerificationEmailSend?: Maybe<UserVerificationEmailSend>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationContactFormSubmitArgs = {
  input: ContactFormInput
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationCustomerUpdateArgs = {
  allowDuplicate?: Scalars['Boolean']['input']
  input: CustomerUpdateInput
  updateAuth0User?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationOrderCancelArgs = {
  cancelReason?: InputMaybe<OrderCancelReason>
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationOrderCreateArgs = {
  input: OrderCreateInput
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationOrderUpdateArgs = {
  id: Scalars['ID']['input']
  input: OrderUpdateInput
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationPriceCalculateArgs = {
  input: PriceCalculateInput
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationReportInvoiceExportArgs = {
  langCd?: InputMaybe<LanguageCode>
  orderId: Scalars['ID']['input']
}

/**
 * The schema’s entry-point for mutations.
 * This acts as the public, top-level API from which all mutation queries must start.
 */
export type MutationUserVerificationEmailSendArgs = {
  input: UserVerificationEmailSendInput
}

/** An object with an ID */
export type Node = {
  /** The ID of the object. */
  id: Scalars['ID']['output']
}

/** NotForSale list collection information */
export type NotForSale = Node & {
  __typename?: 'NotForSale'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The not for sale products information. */
  products?: Maybe<NotForSaleProductsConnection>
  /** Information about the rate. */
  rate?: Maybe<Rate>
}

/** NotForSale list collection information */
export type NotForSaleProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  product?: InputMaybe<Scalars['ID']['input']>
  variantIds?: InputMaybe<Scalars['ID']['input']>
}

export type NotForSaleConnection = {
  __typename?: 'NotForSaleConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotForSaleEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
}

/** A Relay edge containing a `NotForSale` and its cursor. */
export type NotForSaleEdge = {
  __typename?: 'NotForSaleEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<NotForSale>
}

/** Represents not for sale products variation information. */
export type NotForSaleProducts = Node & {
  __typename?: 'NotForSaleProducts'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Information about the product. */
  product?: Maybe<Product>
  /** The ID of the ordered product that was eligible for a refund. */
  variantIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
}

export type NotForSaleProductsConnection = {
  __typename?: 'NotForSaleProductsConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotForSaleProductsEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
}

/** A Relay edge containing a `NotForSaleProducts` and its cursor. */
export type NotForSaleProductsEdge = {
  __typename?: 'NotForSaleProductsEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<NotForSaleProducts>
}

/** ディスカウント適用回数オブジェクト */
export type NumberOfDiscountsApplied = {
  __typename?: 'NumberOfDiscountsApplied'
  numberOfSagaAqua: Scalars['Int']['output']
  numberOfSagaArena: Scalars['Int']['output']
  numberOfSagaPlaza: Scalars['Int']['output']
  numberOfSagaSta: Scalars['Int']['output']
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type Order = Node & {
  __typename?: 'Order'
  /** The approval status of the order. */
  approval: OrderApproval
  /**
   * Whether the reservation requires approval.
   * (approvalRequired)
   */
  approvalRequired: Scalars['Boolean']['output']
  /** Time zone booked by order. */
  bookingDates: Array<BookingDate>
  /** Calendar information. */
  calendar?: Maybe<Calendar>
  /** The reasons to cancel your booking. */
  cancelReason?: Maybe<OrderCancelReason>
  /** The date and time when the booking was canceled. */
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  /** The cost of cancelled reservations. */
  cancellationFee?: Maybe<Scalars['Float']['output']>
  /** Information about the customer representing the group. */
  contactOfRepresentative?: Maybe<Representative>
  /**
   * The date and time the order was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** Information about the customer. */
  customer?: Maybe<Customer>
  /**
   * ディスカウントコレクション
   * ID of the discount what applied the order.
   * (discountId)
   */
  discount?: Maybe<Discount>
  /** 手入力で割引を適用した際の情報 */
  discountFee?: Maybe<DiscountFee>
  /**
   * The discount price.
   * (discountPrice)
   */
  discountPrice?: Maybe<Scalars['Float']['output']>
  /**
   * Whether the customer will be charged for entry.
   * (entryFee)
   */
  entryFee: Scalars['Boolean']['output']
  /** Estimate number linked to the order." */
  estimateNumber?: Maybe<Scalars['String']['output']>
  /** Information about the extension fee. */
  extensionFee?: Maybe<Array<Maybe<ExtensionFee>>>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** List of the order's line items. */
  lineItems?: Maybe<OrderLineItemConnection>
  modifierInfo?: Maybe<OrderModifierConnection>
  /**
   * The number of customers in the group.
   * (numberOfPeople)
   */
  numberOfPeople: Scalars['Int']['output']
  /**
   * The user-identifiable order number.
   * (orderNumber)
   */
  orderNumber: Scalars['Int']['output']
  /**
   * 施設利用料 小計(税込)
   * (originalSubTotalPrice)
   */
  originalSubTotalPrice: Scalars['Float']['output']
  /**
   * 施設利用料 小計(税抜)
   * (originalSubTotalPriceTaxExcluded)
   */
  originalSubTotalPriceTaxExcluded: Scalars['Float']['output']
  /**
   * The total amount including tax at the time of booking.
   * (originalTotalPrice)
   */
  originalTotalPrice: Scalars['Float']['output']
  /**
   * The tax amount at the time of booking.
   * (originalTotalTax)
   */
  originalTotalTax: Scalars['Float']['output']
  /** Payment information. */
  payment?: Maybe<Payment>
  /** Time zone booked by order. */
  period?: Maybe<Period>
  /** Purpose of reservation. */
  purpose?: Maybe<OrderPurpose>
  /** Rate information. */
  rate?: Maybe<RateInfo>
  /**
   * The reason for disapproval of reservation.
   * (reasonForDisapproval)
   */
  reasonForDisapproval?: Maybe<Scalars['String']['output']>
  /**
   * Receipt number linked to the order.
   * (receiptNumber)
   */
  receiptNumber?: Maybe<Scalars['String']['output']>
  /** Refund information. */
  refund?: Maybe<Refund>
  /** 領収証が再発行された場合のフラグ。再発行された場合はTrueになる。 */
  reissue?: Maybe<Scalars['Boolean']['output']>
  /**
   * Whether the customer will be selling goods.
   * (saleOfGoods)
   */
  saleOfGoods: Scalars['Boolean']['output']
  /**
   * The user-identifiable serial number.
   * (serialNumber)
   */
  serialNumber: Scalars['String']['output']
  /**
   * Whether or not the calculated price includes special price.
   * (specialPriceIncluded)
   */
  specialPriceIncluded: Scalars['Boolean']['output']
  /** The order status */
  status: OrderStatus
  /**
   * 予約された施設のドメイン名(例:saga-arena)
   * (storeDomain)
   */
  storeDomain?: Maybe<Scalars['String']['output']>
  /**
   * 小計(税込)
   * (subTotalPrice)
   */
  subTotalPrice: Scalars['Float']['output']
  /**
   * 小計(税抜)
   * (subTotalPriceTaxExcluded)
   */
  subTotalPriceTaxExcluded: Scalars['Float']['output']
  /**
   * The total amount including tax at the time of settlement.
   * (totalPrice)
   */
  totalPrice: Scalars['Float']['output']
  /**
   * The total tax amount at the time of settlement.
   * (totalTax)
   */
  totalTax: Scalars['Float']['output']
  /**
   * The date and time the order was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type OrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  baseTimeUnit?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  colorCode?: InputMaybe<Scalars['String']['input']>
  displayCalendar?: InputMaybe<Scalars['Boolean']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  product?: InputMaybe<Scalars['ID']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  specialPrice?: InputMaybe<Scalars['Float']['input']>
  timeBased?: InputMaybe<Scalars['Boolean']['input']>
  unit?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<Scalars['ID']['input']>
}

/** Represents information about the order such as the reservation date and time and the products to be reserved. */
export type OrderModifierInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>
  modifier?: InputMaybe<Scalars['ID']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
}

/** The Order status type */
export enum OrderApproval {
  /** 承認 */
  Approved = 'APPROVED',
  /** 非承認 */
  Disapproved = 'DISAPPROVED',
  /** 承認待ち */
  Pending = 'PENDING',
}

export type OrderCancel = {
  __typename?: 'OrderCancel'
  /** The cancelled order. */
  order?: Maybe<Order>
  /** List of errors that occurred executing the mutation. */
  orderUserErrors: Array<OrderUserError>
}

/** The Order Cancel Code */
export enum OrderCancelReason {
  /** The customer wanted to cancel the order. */
  Customer = 'CUSTOMER',
  /** Payment was declined. */
  Declined = 'DECLINED',
  /** The order was fraudulent. */
  Fraud = 'FRAUD',
  /** There was insufficient inventory. */
  Inventory = 'INVENTORY',
  /** Some other reason not listed. */
  Other = 'OTHER',
}

export type OrderCreate = {
  __typename?: 'OrderCreate'
  /** The created order. */
  order?: Maybe<Order>
  /** List of errors that occurred executing the mutation. */
  orderUserErrors: Array<OrderUserError>
}

/**
 * Specifies the input fields required to create an order.
 * TODO: バリエーションIDと予約数量をセットで受け取れるようにしたい
 */
export type OrderCreateInput = {
  /** The order's booking date information. */
  bookingDate: BookingDateInput
  /** Information regarding order calendar. */
  calendar?: InputMaybe<CalendarInput>
  /** Information of the customer representing the group. */
  contactOfRepresentative?: InputMaybe<ContactOfRepresentativeInput>
  /** 手入力で施設利用料金から割引 */
  discountFee?: InputMaybe<DiscountFeeInput>
  /** Whether the customer needs to pay an entry fee. */
  entryFee?: InputMaybe<Scalars['Boolean']['input']>
  /** Information regarding order extension fee. */
  extensionFee?: InputMaybe<Array<InputMaybe<ExtensionFeeInput>>>
  /** The number of users. */
  numberOfPeople: Scalars['Int']['input']
  /** Information regarding order payments. */
  payment?: InputMaybe<PaymentInput>
  /** The order's booking time information. */
  period?: InputMaybe<PeriodInput>
  /** The reservation target variant. */
  productVariants: Array<InputMaybe<OrderVariantInput>>
  /** Purpose of the reservation. */
  purpose: OrderPurpose
  /** Id of rate variant from which the order is created. */
  rateVariantId: Scalars['ID']['input']
  saleOfGoods?: InputMaybe<Scalars['Boolean']['input']>
  /** Status of the reservation. */
  status?: InputMaybe<OrderStatus>
}

/**
 * Possible error codes that could be returned by OrderError.
 * TODO: Mutation 実装時に適宜追加
 */
export enum OrderErrorCode {
  /** Payment information is already registered. */
  AlreadyRegistered = 'ALREADY_REGISTERED',
  /** Orders requiring approval cannot be modified. */
  ApprovalRequired = 'APPROVAL_REQUIRED',
  Blank = 'BLANK',
  /** Canceled orders cannot be updated. */
  Canceled = 'CANCELED',
  /** You cannot check-out without checking-in first. */
  CheckinRequired = 'CHECKIN_REQUIRED',
  /** This facility has the Contact Required Flag set to True. */
  ContactRequired = 'CONTACT_REQUIRED',
  /** Unidentified customer. */
  CustomerNotFound = 'CUSTOMER_NOT_FOUND',
  /** The input date does not exist in the order. */
  DateNotFound = 'DATE_NOT_FOUND',
  Disapproved = 'DISAPPROVED',
  /** Input value is duplicate. */
  Duplicate = 'DUPLICATE',
  /** You cannot book the same dates. */
  DuplicateDates = 'DUPLICATE_DATES',
  /** Reservations are not permitted through the reservation system on the first day of each month. */
  ErrReservationNotAllowedOnFirstDay = 'ERR_RESERVATION_NOT_ALLOWED_ON_FIRST_DAY',
  /** Failed to upload file. */
  FailedToUpload = 'FAILED_TO_UPLOAD',
  FutureDate = 'FUTURE_DATE',
  /** Input value is invalid. */
  Invalid = 'INVALID',
  /** Check-in time must be before check-out time. */
  InvalidCheckinTime = 'INVALID_CHECKIN_TIME',
  /** Check-out time must be after check-in time. */
  InvalidCheckoutTime = 'INVALID_CHECKOUT_TIME',
  /** Input dates are invalid. */
  InvalidDate = 'INVALID_DATE',
  /** Start time should be earlier than end time. */
  InvalidPeriod = 'INVALID_PERIOD',
  /** You cannot create or modify orders with start times that are in the past. */
  InvalidStartTime = 'INVALID_START_TIME',
  /** The customer is not flagged as sub-arena reserved. */
  InvalidSubArenaBookableFlag = 'INVALID_SUB_ARENA_BOOKABLE_FLAG',
  /** Failed to send email. */
  MailSendingError = 'MAIL_SENDING_ERROR',
  /** This mutation is not allowed. Please contact the admin. */
  NotAllowed = 'NOT_ALLOWED',
  /** The administrator has not yet authorized you to make a reservation. */
  NotAuthorizationMakeOrder = 'NOT_AUTHORIZATION_MAKE_ORDER',
  /** This booking has not yet been approved. */
  NotBeenApproved = 'NOT_BEEN_APPROVED',
  /** The specified order is not a draft. */
  NotDraft = 'NOT_DRAFT',
  /** The requested variation is not for sale. */
  NotForSale = 'NOT_FOR_SALE',
  /** Order does not exist. */
  NotFound = 'NOT_FOUND',
  /** Organization does not exist. */
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND',
  /** bookingDates must be within periodForSale. */
  OutsidePeriodForSale = 'OUTSIDE_PERIOD_FOR_SALE',
  /** You cannot create orders with overlapping dates and period in other stores. */
  OverlappingOrders = 'OVERLAPPING_ORDERS',
  /** The number of consecutive reservations has been exceeded. */
  OverMaxConsecutiveDays = 'OVER_MAX_CONSECUTIVE_DAYS',
  /** Past orders cannot be modified. */
  PastOrder = 'PAST_ORDER',
  /** Input value is quantity zero. */
  QuantityZero = 'QUANTITY_ZERO',
  /** 'rateVariantId' and 'period' cannot both be provided. */
  RateAndPeriodGiven = 'RATE_AND_PERIOD_GIVEN',
  /** Either 'rateVariantId' or 'period' must be provided. */
  RateAndPeriodMissing = 'RATE_AND_PERIOD_MISSING',
  /** If you have selected "approve", please provide other fields as well. */
  Required = 'REQUIRED',
  /** The requested reservation slot conflicts with an existing reservation. */
  ReservationSlotConflict = 'RESERVATION_SLOT_CONFLICT',
  /** Please update order instead. */
  ShouldBeUpdated = 'SHOULD_BE_UPDATED',
  TimestampDates = 'TIMESTAMP_DATES',
  /** Mutation cannot be called at this time. */
  TooClose = 'TOO_CLOSE',
  TooLong = 'TOO_LONG',
  TooShort = 'TOO_SHORT',
  /** Booking unavailable. */
  Unavailable = 'UNAVAILABLE',
  UnavailableProduct = 'UNAVAILABLE_PRODUCT',
  UndefinedProduct = 'UNDEFINED_PRODUCT',
}

/** Represents a list of ordered products. */
export type OrderLineItem = Node & {
  __typename?: 'OrderLineItem'
  /** SAGAアリーナの予約情報 */
  arenaBookingInfo?: Maybe<Array<Maybe<ArenaBookingInfo>>>
  /**
   * Basic time unit for calculating the bill.
   * (baseTimeUnit)
   */
  baseTimeUnit?: Maybe<Scalars['Int']['output']>
  /** レンダーに表示する際に使用するカラーコード */
  colorCode?: Maybe<Scalars['String']['output']>
  /** カレンダーに表示するか */
  displayCalendar?: Maybe<Scalars['Boolean']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The product name. */
  name: I18nString
  /** The Price of the product to be reserved. */
  price: Scalars['Float']['output']
  /** Information about the product. */
  product?: Maybe<Product>
  /** The number of variant items ordered. */
  quantity: Scalars['Int']['output']
  /**
   * The price for weekends and holidays.
   * (specialPrice)
   */
  specialPrice: Scalars['Float']['output']
  /**
   * Whether it is a variant that charges on an hourly basis.
   * (timeBased)
   */
  timeBased: Scalars['Boolean']['output']
  /** The payment status. */
  unit?: Maybe<Scalars['String']['output']>
  /** The product variation information. */
  variant?: Maybe<Scalars['ID']['output']>
  /** Name of the variant. */
  variantTitle?: Maybe<I18nString>
}

export type OrderLineItemConnection = {
  __typename?: 'OrderLineItemConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderLineItemEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `OrderLineItem` and its cursor. */
export type OrderLineItemEdge = {
  __typename?: 'OrderLineItemEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<OrderLineItem>
}

/** Represents the member who modified the order. */
export type OrderModifier = Node & {
  __typename?: 'OrderModifier'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /**
   * Date and time the order was modified by the member.
   * (modifiedAt)
   */
  modifiedAt: Scalars['DateTime']['output']
  /** ID of the member who modified the order. */
  modifier?: Maybe<Member>
  /** Reason for modifying the order. */
  reason: Scalars['String']['output']
}

export type OrderModifierConnection = {
  __typename?: 'OrderModifierConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OrderModifierEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `OrderModifier` and its cursor. */
export type OrderModifierEdge = {
  __typename?: 'OrderModifierEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<OrderModifier>
}

/** Purpose for booking. */
export enum OrderPurpose {
  /** ライブ・コンサート */
  Concert = 'CONCERT',
  /** イベント利用 */
  Event = 'EVENT',
  /** 一般利用 */
  General = 'GENERAL',
  /** その他 */
  Other = 'OTHER',
  /** スポーツ */
  Sport = 'SPORT',
}

/** The Order status */
export enum OrderStatus {
  /** 確定 */
  Confirmed = 'CONFIRMED',
  /** 下書き */
  Draft = 'DRAFT',
}

/** Updates an exiting order. */
export type OrderUpdate = {
  __typename?: 'OrderUpdate'
  /** The updated order. */
  order?: Maybe<Order>
  /** List of errors that occurred executing the mutation. */
  orderUserErrors: Array<OrderUserError>
}

/** Specifies the input fields required to update an order. */
export type OrderUpdateInput = {
  /** The order's booking date information. */
  bookingDate: BookingDateInput
  /** Information regarding order calendar. */
  calendar?: InputMaybe<CalendarInput>
  /** Information of the customer representing the group. */
  contactOfRepresentative?: InputMaybe<ContactOfRepresentativeInput>
  /** 手入力で施設利用料金から割引 */
  discountFee?: InputMaybe<DiscountFeeInput>
  /** Whether the customer needs to pay an entry fee. */
  entryFee?: InputMaybe<Scalars['Boolean']['input']>
  /** Information regarding order extension fee. */
  extensionFee?: InputMaybe<Array<InputMaybe<ExtensionFeeInput>>>
  /** The number of users. */
  numberOfPeople: Scalars['Int']['input']
  /** Information regarding order payments. */
  payment?: InputMaybe<PaymentInput>
  /** The reservation target variant. */
  productVariants: Array<InputMaybe<OrderVariantInput>>
  /** Purpose of the reservation. */
  purpose: OrderPurpose
  /** Id of rate variant with which the order is updated. */
  rateVariantId: Scalars['ID']['input']
  saleOfGoods?: InputMaybe<Scalars['Boolean']['input']>
  /** Status of the reservation. */
  status?: InputMaybe<OrderStatus>
}

/** Represents an error that happens during execution of a order mutation. */
export type OrderUserError = DisplayableError & {
  __typename?: 'OrderUserError'
  /** Error code to uniquely identify the error. */
  code?: Maybe<OrderErrorCode>
  /** Path to the input field which caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>
  /** The error message. */
  message: Scalars['String']['output']
}

/**
 * Variations of products to order and their quantity.
 * TODO: 備品も対象に含める想定になった場合に quantity を required=True にして mutate を修正
 */
export type OrderVariantInput = {
  /** SAGAアリーナのみバリエーション毎に日付とQuantityを管理する必要があるため、予約作成時に入力されたバリエーション毎の利用日とQuantityを管理する */
  arenaBookingInfo?: InputMaybe<Array<InputMaybe<ArenaBookingInfoInput>>>
  /** Amount of products the customer wants to book. */
  quantity?: InputMaybe<Scalars['Int']['input']>
  /** Id of product variant */
  variantId: Scalars['ID']['input']
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo'
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output']
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output']
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>
}

/** Represents payment information for an order. */
export type Payment = {
  __typename?: 'Payment'
  /** The payment amount. */
  amount?: Maybe<Scalars['Float']['output']>
  /**
   * The reason for a payment error.
   * (errorMessage)
   */
  errorMessage?: Maybe<Scalars['String']['output']>
  /**
   * The date and time when payment was completed.
   * (processedAt)
   */
  processedAt?: Maybe<Scalars['DateTime']['output']>
  /**
   * The refundable deadline.
   * (refundablePeriod)
   */
  refundablePeriod?: Maybe<Scalars['DateTime']['output']>
  /** The payment status. */
  status: PaymentStatus
  /**
   * The date and time the payment information was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
}

export type PaymentInput = {
  /** The payment amount. */
  amount?: InputMaybe<Scalars['Float']['input']>
  /** Payment status. */
  status?: InputMaybe<PaymentStatus>
  /** The total amount refunded. */
  totalRefunded?: InputMaybe<Scalars['Float']['input']>
}

/** The payment status */
export enum PaymentStatus {
  /** 支払い完了 */
  Complete = 'COMPLETE',
  /** 支払不備 */
  Failure = 'FAILURE',
  /** 支払い待ち */
  Wait = 'WAIT',
}

/** A collection that divides and holds the time zones that can be booked. */
export type Period = {
  __typename?: 'Period'
  /** End time. */
  end?: Maybe<Scalars['Time']['output']>
  /** Start time. */
  start?: Maybe<Scalars['Time']['output']>
}

/** Represents the period for sale information. */
export type PeriodForSale = Node & {
  __typename?: 'PeriodForSale'
  /** The date when the variant becomes unavailable for sale. */
  end?: Maybe<Scalars['Date']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The date when the variant becomes available for sale. */
  start?: Maybe<Scalars['Date']['output']>
}

/** The order period information. */
export type PeriodInput = {
  /** The order's end time. */
  end: Scalars['Time']['input']
  /** The order's start time. */
  start: Scalars['Time']['input']
}

/** Prefecture codes with some differences. */
export enum PrefectureCode {
  /** 愛知県 */
  Ai = 'AI',
  /** 秋田県 */
  Ak = 'AK',
  /** 青森県 */
  Ao = 'AO',
  /** 千葉県 */
  Cb = 'CB',
  /** 愛媛県 */
  Eh = 'EH',
  /** 福井県 */
  Fi = 'FI',
  /** 福岡県 */
  Fo = 'FO',
  /** 福島県 */
  Fs = 'FS',
  /** 岐阜県 */
  Gi = 'GI',
  /** 群馬県 */
  Gu = 'GU',
  /** 兵庫県 */
  Hg = 'HG',
  /** 北海道 */
  Hk = 'HK',
  /** 広島県 */
  Hs = 'HS',
  /** 茨城県 */
  Ib = 'IB',
  /** 石川県 */
  Is = 'IS',
  /** 岩手県 */
  It = 'IT',
  /** 香川県 */
  Ka = 'KA',
  /** 鹿児島県 */
  Kg = 'KG',
  /** 神奈川県 */
  Kn = 'KN',
  /** 高知県 */
  Ko = 'KO',
  /** 熊本県 */
  Ku = 'KU',
  /** 京都府 */
  Ky = 'KY',
  /** 三重県 */
  Me = 'ME',
  /** 宮城県 */
  Mg = 'MG',
  /** 宮崎県 */
  Mz = 'MZ',
  /** 長野県 */
  Na = 'NA',
  /** 新潟県 */
  Ni = 'NI',
  /** 奈良県 */
  Nr = 'NR',
  /** 長崎県 */
  Ns = 'NS',
  /** 大分県 */
  Oi = 'OI',
  /** 沖縄県 */
  Ok = 'OK',
  /** 大阪府 */
  Os = 'OS',
  /** 岡山県 */
  Oy = 'OY',
  /** 佐賀県 */
  Sg = 'SG',
  /** 滋賀県 */
  Si = 'SI',
  /** 島根県 */
  Sn = 'SN',
  /** 埼玉県 */
  St = 'ST',
  /** 静岡県 */
  Sz = 'SZ',
  /** 栃木県 */
  Tc = 'TC',
  /** 徳島県 */
  Tk = 'TK',
  /** 富山県 */
  Tm = 'TM',
  /** 鳥取県 */
  Tt = 'TT',
  /** 東京都 */
  Ty = 'TY',
  /** 和歌山県 */
  Wa = 'WA',
  /** 山口県 */
  Ya = 'YA',
  /** 山形県 */
  Yg = 'YG',
  /** 山梨県 */
  Yn = 'YN',
}

export type Price = {
  __typename?: 'Price'
  /** Amount of discount.(減免額) */
  discountPrice?: Maybe<Scalars['Int']['output']>
  /** 施設利用料 小計(税込) */
  originalSubTotalPrice?: Maybe<Scalars['Float']['output']>
  /** 施設利用料 小計(税抜) */
  originalSubTotalPriceTaxExcluded?: Maybe<Scalars['Float']['output']>
  /** Sum of original sub total price and original total tax.(元の小計価格と元の合計税額の合計) */
  originalTotalPrice?: Maybe<Scalars['Float']['output']>
  /** Tax amount of the original sub total price.(元の小計金額) */
  originalTotalTax?: Maybe<Scalars['Float']['output']>
  /** Whether or not the calculated price includes special price. */
  specialPriceIncluded?: Maybe<Scalars['Boolean']['output']>
  /** The total amount excluding tax at the time of settlement.(決済時の税込み総額) */
  subTotalPrice?: Maybe<Scalars['Float']['output']>
  /** The total amount excluding tax at the time of settlement.(決済時の税抜き総額) */
  subTotalPriceTaxExcluded?: Maybe<Scalars['Float']['output']>
  /** The total amount including tax at the time of settlement.(決済時の税込み総額) */
  totalPrice?: Maybe<Scalars['Float']['output']>
  /** The total tax amount at the time of settlement.(決済時の総税額) */
  totalTax?: Maybe<Scalars['Float']['output']>
}

/** Mutation to calculate all price fields */
export type PriceCalculate = {
  __typename?: 'PriceCalculate'
  /** The calculated price. */
  price?: Maybe<Price>
}

/** Input fields needed for price calculation. */
export type PriceCalculateInput = {
  /** The order's booking date information. */
  bookingDates?: InputMaybe<BookingDateInput>
  /** The discount amount. */
  discountFee?: InputMaybe<Scalars['Float']['input']>
  /** The excess amount. */
  exceed?: InputMaybe<Array<InputMaybe<ExtensionFeeInput>>>
  /** The order's booking time information. */
  period: PeriodInput
  /** The reservation target variant. */
  productVariants: Array<InputMaybe<OrderVariantInput>>
}

/**
 * Represents information about product such as name and price.
 * It also includes the price and status of each product variation.
 */
export type Product = Node & {
  __typename?: 'Product'
  /**
   * True if only administrators can create reservations for this product.
   * (adminOnlyReservation)
   */
  adminOnlyReservation: Scalars['Boolean']['output']
  /**
   * Whether the product requires approval.
   * (approvalRequired)
   */
  approvalRequired: Scalars['Boolean']['output']
  /**
   * Basic time unit for calculating the bill.
   * (baseTimeUnit)
   */
  baseTimeUnit?: Maybe<Scalars['Int']['output']>
  /**
   * The date and time the product was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** Represents multilingual product description. */
  description?: Maybe<I18nString>
  /** Represents multilingual product description without HTML tags. */
  descriptionPlainText?: Maybe<Scalars['String']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The images associated with the product. */
  images?: Maybe<Array<Image>>
  /** The map image associated with the product. */
  mapImage?: Maybe<Image>
  /** クリッカブルマップの座標 */
  mapPosition?: Maybe<MapPosition>
  /** Represents multilingual product name. */
  name: I18nString
  /** Represents information about product option list. */
  options?: Maybe<Array<Maybe<ProductOption>>>
  /**
   * The date and time when the product was published Online.
   * (publishedAt)
   */
  publishedAt?: Maybe<Scalars['DateTime']['output']>
  /** The product status. */
  status: ProductStatus
  /**
   * Whether to calculate charges on a 10-minute basis.
   * (timeBased)
   */
  timeBased: Scalars['Boolean']['output']
  /**
   * The date and time the product was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
  /** Represents information about product variation list. */
  variants?: Maybe<ProductVariantConnection>
}

/**
 * Represents information about product such as name and price.
 * It also includes the price and status of each product variation.
 */
export type ProductVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  availableForSale?: InputMaybe<Scalars['Boolean']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  colorCode?: InputMaybe<Scalars['String']['input']>
  compareAtPrice?: InputMaybe<Scalars['Float']['input']>
  displayCalendar?: InputMaybe<Scalars['Boolean']['input']>
  excess?: InputMaybe<Scalars['Float']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  inventory?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  percentageOfProduct?: InputMaybe<Scalars['Float']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  relatedVariations?: InputMaybe<Scalars['String']['input']>
  specialPrice?: InputMaybe<Scalars['Float']['input']>
  unit?: InputMaybe<UnitCode>
}

export type ProductConnection = {
  __typename?: 'ProductConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `Product` and its cursor. */
export type ProductEdge = {
  __typename?: 'ProductEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<Product>
}

/** Represents product option information. */
export type ProductOption = Node & {
  __typename?: 'ProductOption'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Represents the name of a product option. */
  name?: Maybe<I18nString>
  /** The order of the product option in the list of product options. The first position in the list is 1. */
  position: Scalars['Int']['output']
  /** Represents a list of product option values. */
  values?: Maybe<Array<Maybe<I18nString>>>
}

/** The product status */
export enum ProductStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** DRAFT */
  Draft = 'DRAFT',
  /** INACTIVE */
  Inactive = 'INACTIVE',
}

/** Represents product variation information. */
export type ProductVariant = Node & {
  __typename?: 'ProductVariant'
  /**
   * Whether the product variant is available for sale.
   * (availableForSale)
   */
  availableForSale: Scalars['Boolean']['output']
  /** レンダーに表示する際に使用するカラーコード */
  colorCode?: Maybe<Scalars['String']['output']>
  /**
   * The compare-at price of the variant in the default shop currency.
   * (compareAtPrice)
   */
  compareAtPrice?: Maybe<Scalars['Float']['output']>
  /** カレンダーに表示するか */
  displayCalendar?: Maybe<Scalars['Boolean']['output']>
  /** Amount to be charged when the reserved time is exceeded. */
  excess?: Maybe<Scalars['Float']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The variant inventory. */
  inventory?: Maybe<Scalars['Int']['output']>
  /**
   * 施設を分割して貸し出す場合は、予約時にこの数値を合計し予約可能か判定する。
   * (percentageOfProduct)
   */
  percentageOfProduct?: Maybe<Scalars['Float']['output']>
  /**
   * 販売期間のコレクション
   * The period for when the variant is available.
   * (periodForSale)
   */
  periodForSale?: Maybe<PeriodForSale>
  /** The order of the product variant in the list of product variants. The first position in the list is 1. */
  position: Scalars['Int']['output']
  /** The price of the product variant in the default shop currency. */
  price: Scalars['Float']['output']
  /** 関連付けられたバリエーションのリスト。このリストに追加されているバリエーションが予約されている場合は、予約不可。 */
  relatedVariations?: Maybe<Array<Maybe<Scalars['String']['output']>>>
  /** Represents a list of options selected in a variation. */
  selectedOptions?: Maybe<Array<Maybe<SelectedOption>>>
  /**
   * The price for weekends and holidays.
   * (specialPrice)
   */
  specialPrice: Scalars['Float']['output']
  /** Represents the name of a product variation. */
  title: I18nString
  /** バリエーションの料金を計算する単位 */
  unit?: Maybe<UnitCode>
}

export type ProductVariantConnection = {
  __typename?: 'ProductVariantConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductVariantEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `ProductVariant` and its cursor. */
export type ProductVariantEdge = {
  __typename?: 'ProductVariantEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<ProductVariant>
}

/** Variants information for product. */
export type ProductVariants = {
  __typename?: 'ProductVariants'
  /** The product's variant available for sale. */
  availableForSale?: Maybe<Scalars['Boolean']['output']>
  /** The date of the days info. */
  dataOfTheDays?: Maybe<Array<Maybe<DataOfTheDays>>>
  /** This object's id. */
  id?: Maybe<Scalars['ID']['output']>
  /** The product's variant name. */
  name?: Maybe<Scalars['String']['output']>
  /** Whether The product's variant is within the sale period. */
  withinTheSalePeriod?: Maybe<Scalars['Boolean']['output']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRoot = {
  __typename?: 'QueryRoot'
  /** Get a list of products that can be used at the specified date and time. */
  availableProducts?: Maybe<ProductConnection>
  /** Get a month worth of booking availabilities for a specific product. */
  bookingAvailabilitiesList?: Maybe<Array<Maybe<BookingAvailability>>>
  /** Get specific booking status list information. */
  bookingStatusList?: Maybe<BookingStatusList>
  /** Simple booking status confirmation list. */
  bookingStatusOfTheDayForStorefront?: Maybe<BookingStatusOfTheDay>
  /** Simple booking status confirmation month list. */
  bookingStatusOfTheMonthForStorefront?: Maybe<BookingStatusOfTheMonth>
  /** Get specific customer information. */
  customer?: Maybe<Customer>
  /** Get specific holiday information. */
  holiday?: Maybe<Holiday>
  /** Get the holiday list. */
  holidays?: Maybe<HolidayConnection>
  node?: Maybe<Node>
  /** Get specific not for sale information. */
  notForSale?: Maybe<NotForSale>
  /** Get the not for sale list. */
  notForSales?: Maybe<NotForSaleConnection>
  /** ディスカウントの適用残回数 */
  numberOfDiscountApplied?: Maybe<NumberOfDiscountsApplied>
  /** Get specific order information. */
  order?: Maybe<StoreFrontOrder>
  /** Get a list of orders for booking list. */
  orderForBookingList?: Maybe<StoreFrontOrder>
  /** Get a list of orders. */
  orders?: Maybe<StoreFrontOrderConnection>
  /** Get specific product information. */
  product?: Maybe<Product>
  /** Get a list of products. */
  products?: Maybe<ProductConnection>
  /** Get a list of rates. */
  rates?: Maybe<RateConnection>
  /** Get a store information. */
  storeInformation?: Maybe<StoreInformation>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootAvailableProductsArgs = {
  adminOnlyReservation?: InputMaybe<Scalars['Boolean']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>
  baseTimeUnit?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  input?: InputMaybe<AvailableProductsInput>
  last?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  name_Contains?: InputMaybe<Scalars['String']['input']>
  name_Endswith?: InputMaybe<Scalars['String']['input']>
  name_Regex?: InputMaybe<Scalars['String']['input']>
  name_Startswith?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<ProductStatus>
  store?: InputMaybe<Scalars['String']['input']>
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  timeBased?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootBookingAvailabilitiesListArgs = {
  input: BookingAvailabilitiesListInput
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootBookingStatusListArgs = {
  input: BookingStatusListInput
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootBookingStatusOfTheDayForStorefrontArgs = {
  input?: InputMaybe<BookingStatusOfTheDayInput>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootBookingStatusOfTheMonthForStorefrontArgs = {
  date?: InputMaybe<Scalars['Date']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootHolidayArgs = {
  store?: InputMaybe<Scalars['String']['input']>
  year: Scalars['Int']['input']
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootHolidaysArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  store?: InputMaybe<Scalars['String']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootNodeArgs = {
  id: Scalars['ID']['input']
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootNotForSaleArgs = {
  id: Scalars['ID']['input']
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootNotForSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  rate?: InputMaybe<Scalars['ID']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootNumberOfDiscountAppliedArgs = {
  month: Scalars['Date']['input']
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootOrderArgs = {
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootOrderForBookingListArgs = {
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  approval?: InputMaybe<OrderApproval>
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  bookingDates?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Gt?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Gte?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Lt?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Lte?: InputMaybe<Scalars['Date']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  customer?: InputMaybe<Scalars['ID']['input']>
  discount?: InputMaybe<Scalars['ID']['input']>
  discountPrice?: InputMaybe<Scalars['Float']['input']>
  discountPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  discountPrice_Gte?: InputMaybe<Scalars['Float']['input']>
  discountPrice_Lte?: InputMaybe<Scalars['Float']['input']>
  entryFee?: InputMaybe<Scalars['Boolean']['input']>
  estimateNumber?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  numberOfPeople?: InputMaybe<Scalars['Int']['input']>
  numberOfPeople_All?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>
  numberOfPeople_Gte?: InputMaybe<Scalars['Int']['input']>
  numberOfPeople_Lte?: InputMaybe<Scalars['Int']['input']>
  orderNumber?: InputMaybe<Scalars['Int']['input']>
  orderNumber_Contains?: InputMaybe<Scalars['Int']['input']>
  orderNumber_Endswith?: InputMaybe<Scalars['Int']['input']>
  orderNumber_Regex?: InputMaybe<Scalars['Int']['input']>
  orderNumber_Startswith?: InputMaybe<Scalars['Int']['input']>
  originalSubTotalPrice?: InputMaybe<Scalars['Float']['input']>
  originalSubTotalPriceTaxExcluded?: InputMaybe<Scalars['Float']['input']>
  originalSubTotalPriceTaxExcluded_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']['input']>>
  >
  originalSubTotalPriceTaxExcluded_Gte?: InputMaybe<Scalars['Float']['input']>
  originalSubTotalPriceTaxExcluded_Lte?: InputMaybe<Scalars['Float']['input']>
  originalSubTotalPrice_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']['input']>>
  >
  originalSubTotalPrice_Gte?: InputMaybe<Scalars['Float']['input']>
  originalSubTotalPrice_Lte?: InputMaybe<Scalars['Float']['input']>
  originalTotalPrice?: InputMaybe<Scalars['Float']['input']>
  originalTotalPrice_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']['input']>>
  >
  originalTotalPrice_Gte?: InputMaybe<Scalars['Float']['input']>
  originalTotalPrice_Lte?: InputMaybe<Scalars['Float']['input']>
  originalTotalTax?: InputMaybe<Scalars['Float']['input']>
  originalTotalTax_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']['input']>>
  >
  originalTotalTax_Gte?: InputMaybe<Scalars['Float']['input']>
  originalTotalTax_Lte?: InputMaybe<Scalars['Float']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
  productName_Contains?: InputMaybe<Scalars['String']['input']>
  productName_Endswith?: InputMaybe<Scalars['String']['input']>
  productName_Startswith?: InputMaybe<Scalars['String']['input']>
  purpose?: InputMaybe<OrderPurpose>
  reasonForDisapproval?: InputMaybe<Scalars['String']['input']>
  reasonForDisapproval_Contains?: InputMaybe<Scalars['String']['input']>
  reasonForDisapproval_Endswith?: InputMaybe<Scalars['String']['input']>
  reasonForDisapproval_Regex?: InputMaybe<Scalars['String']['input']>
  reasonForDisapproval_Startswith?: InputMaybe<Scalars['String']['input']>
  receiptNumber?: InputMaybe<Scalars['String']['input']>
  reissue?: InputMaybe<Scalars['Boolean']['input']>
  saleOfGoods?: InputMaybe<Scalars['Boolean']['input']>
  serialNumber?: InputMaybe<Scalars['String']['input']>
  serialNumber_Contains?: InputMaybe<Scalars['String']['input']>
  serialNumber_Endswith?: InputMaybe<Scalars['String']['input']>
  serialNumber_Regex?: InputMaybe<Scalars['String']['input']>
  serialNumber_Startswith?: InputMaybe<Scalars['String']['input']>
  sort?: InputMaybe<SortInput>
  specialPriceIncluded?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<OrderStatus>
  storeDomain?: InputMaybe<Scalars['String']['input']>
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  subTotalPrice?: InputMaybe<Scalars['Float']['input']>
  subTotalPriceTaxExcluded?: InputMaybe<Scalars['Float']['input']>
  subTotalPriceTaxExcluded_All?: InputMaybe<
    Array<InputMaybe<Scalars['Float']['input']>>
  >
  subTotalPriceTaxExcluded_Gte?: InputMaybe<Scalars['Float']['input']>
  subTotalPriceTaxExcluded_Lte?: InputMaybe<Scalars['Float']['input']>
  subTotalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  subTotalPrice_Gte?: InputMaybe<Scalars['Float']['input']>
  subTotalPrice_Lte?: InputMaybe<Scalars['Float']['input']>
  totalPrice?: InputMaybe<Scalars['Float']['input']>
  totalPrice_All?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  totalPrice_Gte?: InputMaybe<Scalars['Float']['input']>
  totalPrice_Lte?: InputMaybe<Scalars['Float']['input']>
  totalTax?: InputMaybe<Scalars['Float']['input']>
  totalTax_All?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>
  totalTax_Gte?: InputMaybe<Scalars['Float']['input']>
  totalTax_Lte?: InputMaybe<Scalars['Float']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootProductArgs = {
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootProductsArgs = {
  adminOnlyReservation?: InputMaybe<Scalars['Boolean']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  approvalRequired?: InputMaybe<Scalars['Boolean']['input']>
  baseTimeUnit?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  name_Contains?: InputMaybe<Scalars['String']['input']>
  name_Endswith?: InputMaybe<Scalars['String']['input']>
  name_Regex?: InputMaybe<Scalars['String']['input']>
  name_Startswith?: InputMaybe<Scalars['String']['input']>
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  publishedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  publishedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  status?: InputMaybe<ProductStatus>
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  timeBased?: InputMaybe<Scalars['Boolean']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootRatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<RateStatus>
  stores?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>
  title?: InputMaybe<Scalars['String']['input']>
  title_Contains?: InputMaybe<Scalars['String']['input']>
  title_Endswith?: InputMaybe<Scalars['String']['input']>
  title_Regex?: InputMaybe<Scalars['String']['input']>
  title_Startswith?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_All?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_In?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
  updatedAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  updatedAt_Nin?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>
}

/**
 * The schema’s entry-point for queries.
 * This acts as the public, top-level API from which all queries must start.
 */
export type QueryRootStoreInformationArgs = {
  store?: InputMaybe<Scalars['String']['input']>
}

/** Price list collection information */
export type Rate = Node & {
  __typename?: 'Rate'
  /**
   * The date and time the rate was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** Represents multilingual rate description. */
  description?: Maybe<I18nString>
  /** Represents multilingual product description without HTML tags. */
  descriptionPlainText?: Maybe<Scalars['String']['output']>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** The rate status. */
  status: RateStatus
  /** The title of the rate. */
  title: I18nString
  /**
   * The date and time the rate was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
  /** Represents information about rate variation list. */
  variants?: Maybe<RateVariantConnection>
}

/** Price list collection information */
export type RateVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  position?: InputMaybe<Scalars['Int']['input']>
  rate?: InputMaybe<Scalars['Float']['input']>
}

export type RateConnection = {
  __typename?: 'RateConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RateEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `Rate` and its cursor. */
export type RateEdge = {
  __typename?: 'RateEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<Rate>
}

/** Information about the order rate. */
export type RateInfo = {
  __typename?: 'RateInfo'
  /** The parent Rate object. */
  parent?: Maybe<Rate>
  /** The rate of the rate collection variant. */
  rate: Scalars['Float']['output']
  /** The product variation title. */
  title?: Maybe<I18nString>
  /**
   * ID of the rate variant.
   * (variantId)
   */
  variantId: Scalars['ID']['output']
}

/** The rate status */
export enum RateStatus {
  /** ACTIVE */
  Active = 'ACTIVE',
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** INACTIVE */
  Inactive = 'INACTIVE',
}

/** Represents rate variation information. */
export type RateVariant = Node & {
  __typename?: 'RateVariant'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** A collection that divides and holds the time zones that can be reserved. */
  period?: Maybe<Period>
  /** The position of the rate variant. */
  position?: Maybe<Scalars['Int']['output']>
  /** The rate of the rate collection variant. */
  rate: Scalars['Float']['output']
}

export type RateVariantConnection = {
  __typename?: 'RateVariantConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<RateVariantEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `RateVariant` and its cursor. */
export type RateVariantEdge = {
  __typename?: 'RateVariantEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<RateVariant>
}

/** Represents refund information when a refund is made to the user. */
export type Refund = {
  __typename?: 'Refund'
  /**
   * The date and time the refund information was created.
   * (createAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** The refund amount. */
  duties?: Maybe<Scalars['Float']['output']>
  /** The ID of the ordered product that was eligible for a refund. */
  lineItemIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>
  /** The remarks */
  note?: Maybe<Scalars['String']['output']>
  /** the refund status. */
  status?: Maybe<Scalars['String']['output']>
  /**
   * The refunded amount without tax.
   * (subTotalRefunded)
   */
  subTotalRefunded?: Maybe<Scalars['Float']['output']>
  /** The tax of the sub total refund. */
  tax?: Maybe<Scalars['Float']['output']>
  /**
   * The total amount refunded.
   * (totalRefunded)
   */
  totalRefunded?: Maybe<Scalars['Float']['output']>
  /**
   * The date and time the refund information was created.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
}

/** Export a invoice. */
export type ReportInvoiceExport = {
  __typename?: 'ReportInvoiceExport'
  /** The URL of invoice file. It's valid for 15 minutes. */
  url?: Maybe<Scalars['URL']['output']>
  /** Error information. */
  userErrors: Array<UserError>
}

/** Information about the customer representing the group. */
export type Representative = {
  __typename?: 'Representative'
  /** The customer's email address. */
  email?: Maybe<Scalars['String']['output']>
  /** Name of the customer representing the group. */
  name?: Maybe<Scalars['String']['output']>
  /** The customer's phone number. */
  phone?: Maybe<Scalars['String']['output']>
}

/** Represents information about the options that make up a product variation. */
export type SelectedOption = Node & {
  __typename?: 'SelectedOption'
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** Represents the product options name selected in that variation. */
  name: I18nString
  /** Represents the product options value selected in that variation. */
  value: I18nString
}

/** Sort the data to be acquired by specifying the field and sort format. */
export type SortInput = {
  /**
   * The field on which the sort is based.
   * When targeting child fields, add "__" to the end of the parent field to concatenate.
   */
  field: Scalars['String']['input']
  /** Sort format (ascending or descending). */
  type: SortType
}

/** The sort type of the query. */
export enum SortType {
  /** Ascending */
  Asc = 'ASC',
  /** Descending */
  Desc = 'DESC',
}

export type StoreFrontOrder = Node & {
  __typename?: 'StoreFrontOrder'
  /** The approval status of the order. */
  approval: OrderApproval
  /**
   * Whether the reservation requires approval.
   * (approvalRequired)
   */
  approvalRequired: Scalars['Boolean']['output']
  /** Time zone booked by order. */
  bookingDates: Array<BookingDate>
  /** Calendar information. */
  calendar?: Maybe<Calendar>
  /** The reasons to cancel your booking. */
  cancelReason?: Maybe<OrderCancelReason>
  /** The date and time when the booking was canceled. */
  canceledAt?: Maybe<Scalars['DateTime']['output']>
  /** The cost of cancelled reservations. */
  cancellationFee?: Maybe<Scalars['Float']['output']>
  /** Information about the customer representing the group. */
  contactOfRepresentative?: Maybe<Representative>
  /**
   * The date and time the order was created.
   * (createdAt)
   */
  createdAt: Scalars['DateTime']['output']
  /** Information about the customer. */
  customer?: Maybe<Customer>
  /**
   * ディスカウントコレクション
   * ID of the discount what applied the order.
   * (discountId)
   */
  discount?: Maybe<Discount>
  /** 手入力で割引を適用した際の情報 */
  discountFee?: Maybe<DiscountFee>
  /**
   * The discount price.
   * (discountPrice)
   */
  discountPrice?: Maybe<Scalars['Float']['output']>
  /**
   * Whether the customer will be charged for entry.
   * (entryFee)
   */
  entryFee: Scalars['Boolean']['output']
  /** Estimate number linked to the order." */
  estimateNumber?: Maybe<Scalars['String']['output']>
  /** Information about the extension fee. */
  extensionFee?: Maybe<Array<Maybe<ExtensionFee>>>
  /** The ID of the object. */
  id: Scalars['ID']['output']
  /** List of the order's line items. */
  lineItems?: Maybe<OrderLineItemConnection>
  modifierInfo?: Maybe<OrderModifierConnection>
  /**
   * The number of customers in the group.
   * (numberOfPeople)
   */
  numberOfPeople: Scalars['Int']['output']
  /**
   * The user-identifiable order number.
   * (orderNumber)
   */
  orderNumber: Scalars['Int']['output']
  /**
   * 施設利用料 小計(税込)
   * (originalSubTotalPrice)
   */
  originalSubTotalPrice: Scalars['Float']['output']
  /**
   * 施設利用料 小計(税抜)
   * (originalSubTotalPriceTaxExcluded)
   */
  originalSubTotalPriceTaxExcluded: Scalars['Float']['output']
  /**
   * The total amount including tax at the time of booking.
   * (originalTotalPrice)
   */
  originalTotalPrice: Scalars['Float']['output']
  /**
   * The tax amount at the time of booking.
   * (originalTotalTax)
   */
  originalTotalTax: Scalars['Float']['output']
  /** Payment information. */
  payment?: Maybe<Payment>
  /** Time zone booked by order. */
  period?: Maybe<Period>
  /** Purpose of reservation. */
  purpose?: Maybe<OrderPurpose>
  /** Rate information. */
  rate?: Maybe<RateInfo>
  /**
   * The reason for disapproval of reservation.
   * (reasonForDisapproval)
   */
  reasonForDisapproval?: Maybe<Scalars['String']['output']>
  /**
   * Receipt number linked to the order.
   * (receiptNumber)
   */
  receiptNumber?: Maybe<Scalars['String']['output']>
  /** Refund information. */
  refund?: Maybe<Refund>
  /** 領収証が再発行された場合のフラグ。再発行された場合はTrueになる。 */
  reissue?: Maybe<Scalars['Boolean']['output']>
  /**
   * Whether the customer will be selling goods.
   * (saleOfGoods)
   */
  saleOfGoods: Scalars['Boolean']['output']
  /**
   * The user-identifiable serial number.
   * (serialNumber)
   */
  serialNumber: Scalars['String']['output']
  /**
   * Whether or not the calculated price includes special price.
   * (specialPriceIncluded)
   */
  specialPriceIncluded: Scalars['Boolean']['output']
  /** The order status */
  status: OrderStatus
  /** order's store name */
  store?: Maybe<Scalars['String']['output']>
  /**
   * 予約された施設のドメイン名(例:saga-arena)
   * (storeDomain)
   */
  storeDomain?: Maybe<Scalars['String']['output']>
  /** order number with store name */
  storeOrderNumber?: Maybe<Scalars['String']['output']>
  /**
   * 小計(税込)
   * (subTotalPrice)
   */
  subTotalPrice: Scalars['Float']['output']
  /**
   * 小計(税抜)
   * (subTotalPriceTaxExcluded)
   */
  subTotalPriceTaxExcluded: Scalars['Float']['output']
  /**
   * The total amount including tax at the time of settlement.
   * (totalPrice)
   */
  totalPrice: Scalars['Float']['output']
  /**
   * The total tax amount at the time of settlement.
   * (totalTax)
   */
  totalTax: Scalars['Float']['output']
  /**
   * The date and time the order was updated.
   * (updatedAt)
   */
  updatedAt: Scalars['DateTime']['output']
}

export type StoreFrontOrderLineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  baseTimeUnit?: InputMaybe<Scalars['Int']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  colorCode?: InputMaybe<Scalars['String']['input']>
  displayCalendar?: InputMaybe<Scalars['Boolean']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  product?: InputMaybe<Scalars['ID']['input']>
  quantity?: InputMaybe<Scalars['Int']['input']>
  specialPrice?: InputMaybe<Scalars['Float']['input']>
  timeBased?: InputMaybe<Scalars['Boolean']['input']>
  unit?: InputMaybe<Scalars['String']['input']>
  variant?: InputMaybe<Scalars['ID']['input']>
}

export type StoreFrontOrderModifierInfoArgs = {
  after?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  modifiedAt?: InputMaybe<Scalars['DateTime']['input']>
  modifier?: InputMaybe<Scalars['ID']['input']>
  reason?: InputMaybe<Scalars['String']['input']>
}

export type StoreFrontOrderConnection = {
  __typename?: 'StoreFrontOrderConnection'
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<StoreFrontOrderEdge>>
  /** Pagination data for this connection. */
  pageInfo: PageInfo
  /** Total number of the nodes in this connection. If it is filtered, the totalCount is the total number of filtered nodes. */
  totalCount: Scalars['Int']['output']
}

/** A Relay edge containing a `StoreFrontOrder` and its cursor. */
export type StoreFrontOrderEdge = {
  __typename?: 'StoreFrontOrderEdge'
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output']
  /** The item at the end of the edge */
  node?: Maybe<StoreFrontOrder>
}

/** Represents information about StoreHolidays. */
export type StoreHolidays = {
  __typename?: 'StoreHolidays'
  /** Regularly scheduled monthly dates for holidays. */
  dates?: Maybe<Array<Maybe<Dates>>>
  /**
   * Closed on each day of the week.
   * (daysOfWeek)
   */
  daysOfWeek?: Maybe<Array<Maybe<DaysOfWeek>>>
}

/** Store information for store front. */
export type StoreInformation = {
  __typename?: 'StoreInformation'
  /** Basic time unit for calculating the bill. */
  baseTimeUnit: Scalars['Int']['output']
  /** Represents information about store holidays. */
  holidays?: Maybe<StoreHolidays>
  /** The maximum number of bookings that users can freely create. */
  maxBookingsCount: Scalars['Int']['output']
  /** The maximum number of days that bookings can be made consecutively. */
  maxConsecutiveDays: Scalars['Int']['output']
}

/** 単位コード */
export enum UnitCode {
  /** 日 */
  PerDay = 'PER_DAY',
  /** 時間 */
  PerHour = 'PER_HOUR',
}

/** Represents an error that happens during execution of a coupon rule mutation. */
export type UserError = DisplayableError & {
  __typename?: 'UserError'
  /** Path to the input field which caused the error. */
  field?: Maybe<Array<Scalars['String']['output']>>
  /** The error message. */
  message: Scalars['String']['output']
}

/** Indicates information related to incidental information. */
export type UserMetaData = {
  __typename?: 'UserMetaData'
  /**
   * The reference value for regular recovery.
   * (defaultLimit)
   */
  defaultLimit: Scalars['Int']['output']
  /** The discount rate. */
  discount: Scalars['Float']['output']
  /**
   * The date and time granted.
   * (grantedAt)
   */
  grantedAt: Scalars['DateTime']['output']
  /** The remaining number of discounts available. */
  limit: Scalars['Int']['output']
  /**
   * The whether you can make a reservation for free time.
   * (timeFree)
   */
  timeFree?: Maybe<Scalars['Boolean']['output']>
}

/** Provides Ancillary information fields and values to use when creating a customer. */
export type UserMetaDataInfoUpdateInput = {
  /** The customer's default_limit. */
  defaultLimit?: InputMaybe<Scalars['Int']['input']>
  /** The customer's discount. */
  discount?: InputMaybe<Scalars['Float']['input']>
  /** The customer's granted_at. */
  grantedAt?: InputMaybe<Scalars['DateTime']['input']>
  /** The customer's limit. */
  limit?: InputMaybe<Scalars['Int']['input']>
  /** The customer's time_free. */
  timeFree?: InputMaybe<Scalars['Boolean']['input']>
}

/**
 * Send customize verification mail, calling Auth0 management API jobs verification_email,
 * then send the verification email to specific user whose authID is sent.
 */
export type UserVerificationEmailSend = {
  __typename?: 'UserVerificationEmailSend'
  /** Errors list that occurred executing the mutation or requesting Auth0 management API. */
  userVerificationEmailSendErrors: Array<UserVerificationEmailSendError>
  /** Successful results after requesting Auth0 management API verification_email */
  userVerificationEmailSendResult?: Maybe<UserVerificationEmailSendResult>
}

/**
 * Model of the mutation response when errors occurred executing the mutation
 * or requesting Auth0 management API verification_email.
 */
export type UserVerificationEmailSendError = DisplayableError &
  FailedVerifyMailResponse & {
    __typename?: 'UserVerificationEmailSendError'
    /** The HTTP response code from requesting Auth0 management API verification_email. */
    code?: Maybe<Scalars['String']['output']>
    /** Path to the input field which caused the error. */
    field?: Maybe<Array<Scalars['String']['output']>>
    /** The error message. */
    message: Scalars['String']['output']
  }

/** Input specific user's information whom the verification email expected to send to. */
export type UserVerificationEmailSendInput = {
  /** auth0 ID of the user to send the verification email to. */
  authId: Scalars['String']['input']
}

/** Model of the mutation response when request auth0 management API verification_email successfully. */
export type UserVerificationEmailSendResult = {
  __typename?: 'UserVerificationEmailSendResult'
  id: Scalars['ID']['output']
  /** ID of Auth0 job requested. */
  jobId: Scalars['String']['output']
  /** The Status of Auth0 job requested. */
  jobStatus: Scalars['String']['output']
  /** The Type of Auth0 job requested. */
  jobType: Scalars['String']['output']
}

export type BookingStatusOfTheDayForStorefrontQueryVariables = Exact<{
  input?: InputMaybe<BookingStatusOfTheDayInput>
}>

export type BookingStatusOfTheDayForStorefrontQuery = {
  __typename?: 'QueryRoot'
  bookingStatusOfTheDayForStorefront?: {
    __typename?: 'BookingStatusOfTheDay'
    date?: any | null
    products?: Array<{
      __typename?: 'BookingStatusOfTheDayProducts'
      id: string
      name: string
      variants?: Array<{
        __typename?: 'BookingStatusOfTheDayProductVariants'
        id: string
        name: string
        availableForSale: boolean
        bookings: Array<string>
      }> | null
    }> | null
  } | null
}

export type BookingStatusOfTheMonthForStorefrontQueryVariables = Exact<{
  date?: InputMaybe<Scalars['Date']['input']>
}>

export type BookingStatusOfTheMonthForStorefrontQuery = {
  __typename?: 'QueryRoot'
  bookingStatusOfTheMonthForStorefront?: {
    __typename?: 'BookingStatusOfTheMonth'
    date?: any | null
    products?: Array<{
      __typename?: 'BookingStatusOfTheMonthProducts'
      id: string
      name: string
      variants?: Array<{
        __typename?: 'BookingStatusOfTheMonthProductVariants'
        id: string
        name: string
        availableForSale: boolean
        bookingDates: Array<any | null>
      }> | null
    }> | null
  } | null
}

export type OrderForBookingListQueryVariables = Exact<{
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}>

export type OrderForBookingListQuery = {
  __typename?: 'QueryRoot'
  orderForBookingList?: {
    __typename?: 'StoreFrontOrder'
    approval: OrderApproval
    approvalRequired: boolean
    createdAt: any
    discountPrice?: number | null
    entryFee: boolean
    id: string
    numberOfPeople: number
    orderNumber: number
    originalSubTotalPrice: number
    originalSubTotalPriceTaxExcluded: number
    originalTotalPrice: number
    originalTotalTax: number
    reasonForDisapproval?: string | null
    saleOfGoods: boolean
    serialNumber: string
    specialPriceIncluded: boolean
    status: OrderStatus
    subTotalPrice: number
    subTotalPriceTaxExcluded: number
    totalPrice: number
    totalTax: number
    updatedAt: any
    canceledAt?: any | null
    cancelReason?: OrderCancelReason | null
    purpose?: OrderPurpose | null
    store?: string | null
    storeOrderNumber?: string | null
    bookingDates: Array<{
      __typename?: 'BookingDate'
      exceededTime?: any | null
      date: any
      checkedOutAt?: any | null
      checkedInAt?: any | null
    }>
    calendar?: {
      __typename?: 'Calendar'
      approval: boolean
      eventName?: string | null
      organizer?: string | null
      publishableDate?: any | null
    } | null
    lineItems?: {
      __typename?: 'OrderLineItemConnection'
      edges: Array<{
        __typename?: 'OrderLineItemEdge'
        lineItem?: {
          __typename?: 'OrderLineItem'
          id: string
          price: number
          quantity: number
          timeBased: boolean
          variant?: string | null
          specialPrice: number
          name: { __typename?: 'I18nString'; jaJp: string }
          product?: {
            __typename?: 'Product'
            id: string
            baseTimeUnit?: number | null
            status: ProductStatus
            approvalRequired: boolean
            timeBased: boolean
            createdAt: any
            updatedAt: any
            publishedAt?: any | null
            name: { __typename?: 'I18nString'; jaJp: string }
            description?: { __typename?: 'I18nString'; jaJp: string } | null
            images?: Array<{
              __typename?: 'Image'
              altText?: string | null
              filename: string
              id: string
              src: any
              key: string
              mimeType: string
            }> | null
            mapImage?: {
              __typename?: 'Image'
              altText?: string | null
              filename: string
              id: string
              src: any
              key: string
              mimeType: string
            } | null
            options?: Array<{
              __typename?: 'ProductOption'
              id: string
              position: number
              name?: { __typename?: 'I18nString'; jaJp: string } | null
              values?: Array<{
                __typename?: 'I18nString'
                jaJp: string
              } | null> | null
            } | null> | null
            variants?: {
              __typename?: 'ProductVariantConnection'
              totalCount: number
              edges: Array<{
                __typename?: 'ProductVariantEdge'
                cursor: string
                variant?: {
                  __typename?: 'ProductVariant'
                  id: string
                  unit?: UnitCode | null
                  availableForSale: boolean
                  price: number
                  compareAtPrice?: number | null
                  excess?: number | null
                  inventory?: number | null
                  position: number
                  specialPrice: number
                  title: { __typename?: 'I18nString'; jaJp: string }
                  selectedOptions?: Array<{
                    __typename?: 'SelectedOption'
                    id: string
                    name: { __typename?: 'I18nString'; jaJp: string }
                    value: { __typename?: 'I18nString'; jaJp: string }
                  } | null> | null
                  periodForSale?: {
                    __typename?: 'PeriodForSale'
                    start?: any | null
                    end?: any | null
                  } | null
                } | null
              } | null>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                hasPreviousPage: boolean
                startCursor?: string | null
                endCursor?: string | null
              }
            } | null
          } | null
          arenaBookingInfo?: Array<{
            __typename?: 'ArenaBookingInfo'
            dateOfUse: any
            quantity: number
          } | null> | null
          variantTitle?: { __typename?: 'I18nString'; jaJp: string } | null
        } | null
      } | null>
    } | null
    payment?: {
      __typename?: 'Payment'
      amount?: number | null
      errorMessage?: string | null
      processedAt?: any | null
      refundablePeriod?: any | null
      status: PaymentStatus
      updatedAt: any
    } | null
    period?: {
      __typename?: 'Period'
      start?: any | null
      end?: any | null
    } | null
    rate?: {
      __typename?: 'RateInfo'
      rate: number
      variantId: string
      parent?: {
        __typename?: 'Rate'
        id: string
        status: RateStatus
        description?: { __typename?: 'I18nString'; jaJp: string } | null
        variants?: {
          __typename?: 'RateVariantConnection'
          totalCount: number
          edges: Array<{
            __typename?: 'RateVariantEdge'
            variant?: {
              __typename?: 'RateVariant'
              id: string
              position?: number | null
              rate: number
              period?: {
                __typename?: 'Period'
                start?: any | null
                end?: any | null
              } | null
            } | null
          } | null>
        } | null
      } | null
      title?: { __typename?: 'I18nString'; jaJp: string } | null
    } | null
    refund?: {
      __typename?: 'Refund'
      createdAt: any
      duties?: number | null
      lineItemIds?: Array<string | null> | null
      note?: string | null
      status?: string | null
      subTotalRefunded?: number | null
      tax?: number | null
      totalRefunded?: number | null
      updatedAt: any
    } | null
  } | null
}

export type ContactFormSubmitMutationVariables = Exact<{
  input: ContactFormInput
}>

export type ContactFormSubmitMutation = {
  __typename?: 'Mutation'
  contactFormSubmit?: {
    __typename?: 'ContactFormSubmit'
    contactForm?: {
      __typename?: 'ContactForm'
      email: string
      message: string
      name: string
      queryType: string
      refNumber: string
      subject: string
    } | null
    contactFormUserErrors: Array<{
      __typename?: 'ContactFormUserError'
      field?: Array<string> | null
      message: string
      code?: ContactFormErrorCode | null
    }>
  } | null
}

export type CustomerFragment = {
  __typename?: 'Customer'
  bookableFlag: boolean
  firstName: string
  email?: string | null
  corporationName?: string | null
  corporationNameKana?: string | null
  lastName: string
  id: string
  isActive: boolean
  phone?: string | null
  type: CustomerType
  address?: {
    __typename?: 'Address'
    address1: string
    address2?: string | null
    city: string
    country?: string | null
    prefecture?: string | null
    prefectureCode?: PrefectureCode | null
    zip: string
  } | null
  appliedDiscount?: {
    __typename?: 'AppliedDiscount'
    discounts?: {
      __typename?: 'DiscountConnection'
      edges: Array<{
        __typename?: 'DiscountEdge'
        node?: {
          __typename?: 'Discount'
          id: string
          description?: string | null
          discountPercent?: {
            __typename?: 'DiscountPercent'
            denominator: number
            numerator: number
            discountPercentLabel: DiscountPercentLabel
          } | null
        } | null
      } | null>
    } | null
  } | null
}

export type CustomerMetaFragment = {
  __typename?: 'Customer'
  userMetaData?: {
    __typename?: 'UserMetaData'
    defaultLimit: number
    discount: number
    grantedAt: any
    limit: number
    timeFree?: boolean | null
  } | null
}

export type CustomerQueryVariables = Exact<{ [key: string]: never }>

export type CustomerQuery = {
  __typename?: 'QueryRoot'
  customer?: {
    __typename?: 'Customer'
    auth0Id?: string | null
    bookableFlag: boolean
    email?: string | null
    firstName: string
    fullname?: string | null
    id: string
    lastName: string
    isActive: boolean
    note?: string | null
    phone?: string | null
    tags?: Array<string | null> | null
    type: CustomerType
    corporationName?: string | null
    createdAt: any
    updatedAt: any
    address?: {
      __typename?: 'Address'
      address1: string
      address2?: string | null
      city: string
      countryCode?: CountryCode | null
      country?: string | null
      prefecture?: string | null
      prefectureCode?: PrefectureCode | null
      zip: string
    } | null
    appliedDiscount?: {
      __typename?: 'AppliedDiscount'
      discounts?: {
        __typename?: 'DiscountConnection'
        edges: Array<{
          __typename?: 'DiscountEdge'
          node?: { __typename?: 'Discount'; id: string } | null
        } | null>
      } | null
    } | null
    userMetaData?: {
      __typename?: 'UserMetaData'
      defaultLimit: number
      discount: number
      grantedAt: any
      limit: number
      timeFree?: boolean | null
    } | null
    metaFields?: {
      __typename?: 'MetaFieldConnection'
      edges: Array<{
        __typename?: 'MetaFieldEdge'
        node?: { __typename?: 'MetaField'; id: string; key: string } | null
      } | null>
    } | null
  } | null
}

export type CustomerUpdateMutationVariables = Exact<{
  input: CustomerUpdateInput
  updateAuth0User?: InputMaybe<Scalars['Boolean']['input']>
  allowDuplicate: Scalars['Boolean']['input']
}>

export type CustomerUpdateMutation = {
  __typename?: 'Mutation'
  customerUpdate?: {
    __typename?: 'CustomerUpdate'
    customer?: { __typename?: 'Customer'; id: string } | null
    customerUserErrors: Array<{
      __typename?: 'CustomerUserError'
      field?: Array<string> | null
      code?: CustomerErrorCode | null
      message: string
    }>
  } | null
}

export type NumberOfDiscountAppliedQueryVariables = Exact<{
  month: Scalars['Date']['input']
}>

export type NumberOfDiscountAppliedQuery = {
  __typename?: 'QueryRoot'
  numberOfDiscountApplied?: {
    __typename?: 'NumberOfDiscountsApplied'
    numberOfSagaAqua: number
    numberOfSagaArena: number
    numberOfSagaPlaza: number
    numberOfSagaSta: number
  } | null
}

export type HolidaysQueryVariables = Exact<{
  store?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['ID']['input']>
  year?: InputMaybe<Scalars['Int']['input']>
}>

export type HolidaysQuery = {
  __typename?: 'QueryRoot'
  holidays?: {
    __typename?: 'HolidayConnection'
    totalCount: number
    edges: Array<{
      __typename?: 'HolidayEdge'
      node?: {
        __typename?: 'Holiday'
        id: string
        year: number
        holidays?: {
          __typename?: 'HolidaysConnection'
          edges: Array<{
            __typename?: 'HolidaysEdge'
            node?: {
              __typename?: 'Holidays'
              date: any
              id: string
              isAutoGenerated: boolean
              isClose: boolean
              isPublic: boolean
              reason?: {
                __typename?: 'I18nString'
                jaJp: string
                enUs?: string | null
              } | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
  } | null
}

export type HolidayQueryVariables = Exact<{
  year: Scalars['Int']['input']
  store?: InputMaybe<Scalars['String']['input']>
}>

export type HolidayQuery = {
  __typename?: 'QueryRoot'
  holiday?: {
    __typename?: 'Holiday'
    id: string
    year: number
    holidays?: {
      __typename?: 'HolidaysConnection'
      edges: Array<{
        __typename?: 'HolidaysEdge'
        node?: {
          __typename?: 'Holidays'
          date: any
          id: string
          isClose: boolean
          isPublic: boolean
          isAutoGenerated: boolean
          reason?: {
            __typename?: 'I18nString'
            jaJp: string
            enUs?: string | null
          } | null
        } | null
      } | null>
    } | null
  } | null
}

export type BookingStatusListQueryVariables = Exact<{
  input: BookingStatusListInput
  store?: InputMaybe<Scalars['String']['input']>
}>

export type BookingStatusListQuery = {
  __typename?: 'QueryRoot'
  bookingStatusList?: {
    __typename?: 'BookingStatusList'
    productId?: string | null
    productName?: string | null
    productVariants?: Array<{
      __typename?: 'ProductVariants'
      id?: string | null
      name?: string | null
      availableForSale?: boolean | null
      withinTheSalePeriod?: boolean | null
      dataOfTheDays?: Array<{
        __typename?: 'DataOfTheDays'
        name?: string | null
        bookings?: Array<number | null> | null
      } | null> | null
    } | null> | null
  } | null
}

export type StoreInformationQueryVariables = Exact<{
  store?: InputMaybe<Scalars['String']['input']>
}>

export type StoreInformationQuery = {
  __typename?: 'QueryRoot'
  storeInformation?: {
    __typename?: 'StoreInformation'
    baseTimeUnit: number
    maxConsecutiveDays: number
    maxBookingsCount: number
    holidays?: {
      __typename?: 'StoreHolidays'
      dates?: Array<{
        __typename?: 'Dates'
        date?: number | null
      } | null> | null
      daysOfWeek?: Array<{
        __typename?: 'DaysOfWeek'
        name?: string | null
        nth?: number | null
      } | null> | null
    } | null
  } | null
}

export type PriceCalculateMutationVariables = Exact<{
  input: PriceCalculateInput
}>

export type PriceCalculateMutation = {
  __typename?: 'Mutation'
  priceCalculate?: {
    __typename?: 'PriceCalculate'
    price?: {
      __typename?: 'Price'
      originalSubTotalPrice?: number | null
      originalSubTotalPriceTaxExcluded?: number | null
      originalTotalTax?: number | null
      originalTotalPrice?: number | null
      subTotalPrice?: number | null
      subTotalPriceTaxExcluded?: number | null
      totalTax?: number | null
      totalPrice?: number | null
      specialPriceIncluded?: boolean | null
      discountPrice?: number | null
    } | null
  } | null
}

export type ReportInvoiceExportMutationVariables = Exact<{
  langCd?: InputMaybe<LanguageCode>
  orderId: Scalars['ID']['input']
}>

export type ReportInvoiceExportMutation = {
  __typename?: 'Mutation'
  reportInvoiceExport?: {
    __typename?: 'ReportInvoiceExport'
    url?: any | null
    userErrors: Array<{
      __typename?: 'UserError'
      field?: Array<string> | null
      message: string
    }>
  } | null
}

export type GetBookingAvailabilitiesListQueryVariables = Exact<{
  input: BookingAvailabilitiesListInput
  store?: InputMaybe<Scalars['String']['input']>
}>

export type GetBookingAvailabilitiesListQuery = {
  __typename?: 'QueryRoot'
  bookingAvailabilitiesList?: Array<{
    __typename?: 'BookingAvailability'
    date?: any | null
    availability?: Availabilities | null
  } | null> | null
}

export type UserVerificationEmailSendMutationVariables = Exact<{
  input: UserVerificationEmailSendInput
}>

export type UserVerificationEmailSendMutation = {
  __typename?: 'Mutation'
  userVerificationEmailSend?: {
    __typename?: 'UserVerificationEmailSend'
    userVerificationEmailSendResult?: {
      __typename?: 'UserVerificationEmailSendResult'
      jobId: string
      jobType: string
      jobStatus: string
    } | null
    userVerificationEmailSendErrors: Array<{
      __typename?: 'UserVerificationEmailSendError'
      field?: Array<string> | null
      message: string
      code?: string | null
    }>
  } | null
}

export type OrdersQueryVariables = Exact<{
  approval?: InputMaybe<OrderApproval>
  bookingDates?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Lt?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Lte?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Gt?: InputMaybe<Scalars['Date']['input']>
  bookingDates_Gte?: InputMaybe<Scalars['Date']['input']>
  createdAt_Lte?: InputMaybe<Scalars['DateTime']['input']>
  createdAt_Gte?: InputMaybe<Scalars['DateTime']['input']>
  orderNumber?: InputMaybe<Scalars['Int']['input']>
  productName?: InputMaybe<Scalars['String']['input']>
  productName_Startswith?: InputMaybe<Scalars['String']['input']>
  productName_Endswith?: InputMaybe<Scalars['String']['input']>
  productName_Contains?: InputMaybe<Scalars['String']['input']>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
  sort?: InputMaybe<SortInput>
  stores?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >
}>

export type OrdersQuery = {
  __typename?: 'QueryRoot'
  orders?: {
    __typename?: 'StoreFrontOrderConnection'
    totalCount: number
    edges: Array<{
      __typename?: 'StoreFrontOrderEdge'
      cursor: string
      order?: {
        __typename?: 'StoreFrontOrder'
        approval: OrderApproval
        approvalRequired: boolean
        createdAt: any
        entryFee: boolean
        id: string
        status: OrderStatus
        numberOfPeople: number
        orderNumber: number
        originalSubTotalPrice: number
        originalTotalPrice: number
        originalTotalTax: number
        reasonForDisapproval?: string | null
        saleOfGoods: boolean
        serialNumber: string
        specialPriceIncluded: boolean
        subTotalPrice: number
        totalPrice: number
        totalTax: number
        updatedAt: any
        canceledAt?: any | null
        store?: string | null
        storeOrderNumber?: string | null
        bookingDates: Array<{
          __typename?: 'BookingDate'
          exceededTime?: any | null
          date: any
          checkedOutAt?: any | null
          checkedInAt?: any | null
        }>
        calendar?: {
          __typename?: 'Calendar'
          approval: boolean
          eventName?: string | null
          organizer?: string | null
          publishableDate?: any | null
        } | null
        contactOfRepresentative?: {
          __typename?: 'Representative'
          email?: string | null
          name?: string | null
          phone?: string | null
        } | null
        customer?: {
          __typename?: 'Customer'
          auth0Id?: string | null
          firstName: string
          fullname?: string | null
          lastName: string
          bookableFlag: boolean
          email?: string | null
          corporationName?: string | null
          corporationNameKana?: string | null
          id: string
          isActive: boolean
          phone?: string | null
          type: CustomerType
          address?: {
            __typename?: 'Address'
            address1: string
            address2?: string | null
            city: string
            country?: string | null
            prefecture?: string | null
            prefectureCode?: PrefectureCode | null
            zip: string
          } | null
          appliedDiscount?: {
            __typename?: 'AppliedDiscount'
            discounts?: {
              __typename?: 'DiscountConnection'
              edges: Array<{
                __typename?: 'DiscountEdge'
                node?: {
                  __typename?: 'Discount'
                  id: string
                  description?: string | null
                  discountPercent?: {
                    __typename?: 'DiscountPercent'
                    denominator: number
                    numerator: number
                    discountPercentLabel: DiscountPercentLabel
                  } | null
                } | null
              } | null>
            } | null
          } | null
          userMetaData?: {
            __typename?: 'UserMetaData'
            defaultLimit: number
            discount: number
            grantedAt: any
            limit: number
            timeFree?: boolean | null
          } | null
        } | null
        lineItems?: {
          __typename?: 'OrderLineItemConnection'
          edges: Array<{
            __typename?: 'OrderLineItemEdge'
            lineItem?: {
              __typename?: 'OrderLineItem'
              id: string
              price: number
              quantity: number
              timeBased: boolean
              variant?: string | null
              specialPrice: number
              name: { __typename?: 'I18nString'; jaJp: string }
              arenaBookingInfo?: Array<{
                __typename?: 'ArenaBookingInfo'
                dateOfUse: any
                quantity: number
              } | null> | null
              product?: {
                __typename?: 'Product'
                id: string
                baseTimeUnit?: number | null
                status: ProductStatus
                approvalRequired: boolean
                timeBased: boolean
                createdAt: any
                updatedAt: any
                publishedAt?: any | null
                name: { __typename?: 'I18nString'; jaJp: string }
                description?: { __typename?: 'I18nString'; jaJp: string } | null
                images?: Array<{
                  __typename?: 'Image'
                  altText?: string | null
                  filename: string
                  id: string
                  src: any
                  key: string
                  mimeType: string
                }> | null
                mapImage?: {
                  __typename?: 'Image'
                  altText?: string | null
                  filename: string
                  id: string
                  src: any
                  key: string
                  mimeType: string
                } | null
                options?: Array<{
                  __typename?: 'ProductOption'
                  id: string
                  position: number
                  name?: { __typename?: 'I18nString'; jaJp: string } | null
                  values?: Array<{
                    __typename?: 'I18nString'
                    jaJp: string
                  } | null> | null
                } | null> | null
                variants?: {
                  __typename?: 'ProductVariantConnection'
                  totalCount: number
                  edges: Array<{
                    __typename?: 'ProductVariantEdge'
                    cursor: string
                    variant?: {
                      __typename?: 'ProductVariant'
                      id: string
                      availableForSale: boolean
                      price: number
                      compareAtPrice?: number | null
                      excess?: number | null
                      inventory?: number | null
                      position: number
                      specialPrice: number
                      title: { __typename?: 'I18nString'; jaJp: string }
                      selectedOptions?: Array<{
                        __typename?: 'SelectedOption'
                        id: string
                        name: { __typename?: 'I18nString'; jaJp: string }
                        value: { __typename?: 'I18nString'; jaJp: string }
                      } | null> | null
                      periodForSale?: {
                        __typename?: 'PeriodForSale'
                        start?: any | null
                        end?: any | null
                      } | null
                    } | null
                  } | null>
                  pageInfo: {
                    __typename?: 'PageInfo'
                    hasNextPage: boolean
                    hasPreviousPage: boolean
                    startCursor?: string | null
                    endCursor?: string | null
                  }
                } | null
              } | null
              variantTitle?: { __typename?: 'I18nString'; jaJp: string } | null
            } | null
          } | null>
        } | null
        payment?: {
          __typename?: 'Payment'
          amount?: number | null
          errorMessage?: string | null
          processedAt?: any | null
          refundablePeriod?: any | null
          status: PaymentStatus
          updatedAt: any
        } | null
        period?: {
          __typename?: 'Period'
          start?: any | null
          end?: any | null
        } | null
      } | null
    } | null>
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
  } | null
}

export type OrderQueryVariables = Exact<{
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}>

export type OrderQuery = {
  __typename?: 'QueryRoot'
  order?: {
    __typename?: 'StoreFrontOrder'
    approval: OrderApproval
    approvalRequired: boolean
    createdAt: any
    discountPrice?: number | null
    entryFee: boolean
    id: string
    numberOfPeople: number
    orderNumber: number
    originalSubTotalPrice: number
    originalSubTotalPriceTaxExcluded: number
    originalTotalPrice: number
    originalTotalTax: number
    reasonForDisapproval?: string | null
    saleOfGoods: boolean
    serialNumber: string
    specialPriceIncluded: boolean
    status: OrderStatus
    subTotalPrice: number
    subTotalPriceTaxExcluded: number
    totalPrice: number
    totalTax: number
    updatedAt: any
    canceledAt?: any | null
    cancelReason?: OrderCancelReason | null
    purpose?: OrderPurpose | null
    store?: string | null
    storeOrderNumber?: string | null
    bookingDates: Array<{
      __typename?: 'BookingDate'
      exceededTime?: any | null
      date: any
      checkedOutAt?: any | null
      checkedInAt?: any | null
    }>
    calendar?: {
      __typename?: 'Calendar'
      approval: boolean
      eventName?: string | null
      organizer?: string | null
      publishableDate?: any | null
    } | null
    contactOfRepresentative?: {
      __typename?: 'Representative'
      email?: string | null
      name?: string | null
      phone?: string | null
    } | null
    customer?: {
      __typename?: 'Customer'
      auth0Id?: string | null
      firstName: string
      fullname?: string | null
      lastName: string
      bookableFlag: boolean
      email?: string | null
      corporationName?: string | null
      corporationNameKana?: string | null
      id: string
      isActive: boolean
      phone?: string | null
      type: CustomerType
      address?: {
        __typename?: 'Address'
        address1: string
        address2?: string | null
        city: string
        country?: string | null
        prefecture?: string | null
        prefectureCode?: PrefectureCode | null
        zip: string
      } | null
      appliedDiscount?: {
        __typename?: 'AppliedDiscount'
        discounts?: {
          __typename?: 'DiscountConnection'
          edges: Array<{
            __typename?: 'DiscountEdge'
            node?: {
              __typename?: 'Discount'
              id: string
              description?: string | null
              discountPercent?: {
                __typename?: 'DiscountPercent'
                denominator: number
                numerator: number
                discountPercentLabel: DiscountPercentLabel
              } | null
            } | null
          } | null>
        } | null
      } | null
      userMetaData?: {
        __typename?: 'UserMetaData'
        defaultLimit: number
        discount: number
        grantedAt: any
        limit: number
        timeFree?: boolean | null
      } | null
    } | null
    lineItems?: {
      __typename?: 'OrderLineItemConnection'
      edges: Array<{
        __typename?: 'OrderLineItemEdge'
        lineItem?: {
          __typename?: 'OrderLineItem'
          id: string
          price: number
          quantity: number
          timeBased: boolean
          variant?: string | null
          specialPrice: number
          name: { __typename?: 'I18nString'; jaJp: string }
          product?: {
            __typename?: 'Product'
            id: string
            baseTimeUnit?: number | null
            status: ProductStatus
            approvalRequired: boolean
            timeBased: boolean
            createdAt: any
            updatedAt: any
            publishedAt?: any | null
            name: { __typename?: 'I18nString'; jaJp: string }
            description?: { __typename?: 'I18nString'; jaJp: string } | null
            images?: Array<{
              __typename?: 'Image'
              altText?: string | null
              filename: string
              id: string
              src: any
              key: string
              mimeType: string
            }> | null
            mapImage?: {
              __typename?: 'Image'
              altText?: string | null
              filename: string
              id: string
              src: any
              key: string
              mimeType: string
            } | null
            options?: Array<{
              __typename?: 'ProductOption'
              id: string
              position: number
              name?: { __typename?: 'I18nString'; jaJp: string } | null
              values?: Array<{
                __typename?: 'I18nString'
                jaJp: string
              } | null> | null
            } | null> | null
            variants?: {
              __typename?: 'ProductVariantConnection'
              totalCount: number
              edges: Array<{
                __typename?: 'ProductVariantEdge'
                cursor: string
                variant?: {
                  __typename?: 'ProductVariant'
                  id: string
                  unit?: UnitCode | null
                  availableForSale: boolean
                  price: number
                  compareAtPrice?: number | null
                  excess?: number | null
                  inventory?: number | null
                  position: number
                  specialPrice: number
                  title: { __typename?: 'I18nString'; jaJp: string }
                  selectedOptions?: Array<{
                    __typename?: 'SelectedOption'
                    id: string
                    name: { __typename?: 'I18nString'; jaJp: string }
                    value: { __typename?: 'I18nString'; jaJp: string }
                  } | null> | null
                  periodForSale?: {
                    __typename?: 'PeriodForSale'
                    start?: any | null
                    end?: any | null
                  } | null
                } | null
              } | null>
              pageInfo: {
                __typename?: 'PageInfo'
                hasNextPage: boolean
                hasPreviousPage: boolean
                startCursor?: string | null
                endCursor?: string | null
              }
            } | null
          } | null
          arenaBookingInfo?: Array<{
            __typename?: 'ArenaBookingInfo'
            dateOfUse: any
            quantity: number
          } | null> | null
          variantTitle?: { __typename?: 'I18nString'; jaJp: string } | null
        } | null
      } | null>
    } | null
    payment?: {
      __typename?: 'Payment'
      amount?: number | null
      errorMessage?: string | null
      processedAt?: any | null
      refundablePeriod?: any | null
      status: PaymentStatus
      updatedAt: any
    } | null
    period?: {
      __typename?: 'Period'
      start?: any | null
      end?: any | null
    } | null
    rate?: {
      __typename?: 'RateInfo'
      rate: number
      variantId: string
      parent?: {
        __typename?: 'Rate'
        id: string
        status: RateStatus
        description?: { __typename?: 'I18nString'; jaJp: string } | null
        variants?: {
          __typename?: 'RateVariantConnection'
          totalCount: number
          edges: Array<{
            __typename?: 'RateVariantEdge'
            variant?: {
              __typename?: 'RateVariant'
              id: string
              position?: number | null
              rate: number
              period?: {
                __typename?: 'Period'
                start?: any | null
                end?: any | null
              } | null
            } | null
          } | null>
        } | null
      } | null
      title?: { __typename?: 'I18nString'; jaJp: string } | null
    } | null
    refund?: {
      __typename?: 'Refund'
      createdAt: any
      duties?: number | null
      lineItemIds?: Array<string | null> | null
      note?: string | null
      status?: string | null
      subTotalRefunded?: number | null
      tax?: number | null
      totalRefunded?: number | null
      updatedAt: any
    } | null
  } | null
}

export type OrderUpdateMutationVariables = Exact<{
  id: Scalars['ID']['input']
  input: OrderUpdateInput
  store?: InputMaybe<Scalars['String']['input']>
}>

export type OrderUpdateMutation = {
  __typename?: 'Mutation'
  orderUpdate?: {
    __typename?: 'OrderUpdate'
    order?: { __typename?: 'Order'; id: string } | null
    orderUserErrors: Array<{
      __typename?: 'OrderUserError'
      field?: Array<string> | null
      message: string
      code?: OrderErrorCode | null
    }>
  } | null
}

export type OrderCreateMutationVariables = Exact<{
  input: OrderCreateInput
  store?: InputMaybe<Scalars['String']['input']>
}>

export type OrderCreateMutation = {
  __typename?: 'Mutation'
  orderCreate?: {
    __typename?: 'OrderCreate'
    order?: {
      __typename?: 'Order'
      id: string
      discountPrice?: number | null
      serialNumber: string
      originalSubTotalPrice: number
      originalTotalPrice: number
      originalTotalTax: number
      totalTax: number
      specialPriceIncluded: boolean
      calendar?: {
        __typename?: 'Calendar'
        approval: boolean
        organizer?: string | null
        eventName?: string | null
        publishableDate?: any | null
      } | null
    } | null
    orderUserErrors: Array<{
      __typename?: 'OrderUserError'
      field?: Array<string> | null
      message: string
      code?: OrderErrorCode | null
    }>
  } | null
}

export type OrderCancelMutationVariables = Exact<{
  id: Scalars['ID']['input']
  cancelReason?: InputMaybe<OrderCancelReason>
  store?: InputMaybe<Scalars['String']['input']>
}>

export type OrderCancelMutation = {
  __typename?: 'Mutation'
  orderCancel?: {
    __typename?: 'OrderCancel'
    order?: { __typename?: 'Order'; id: string } | null
    orderUserErrors: Array<{
      __typename?: 'OrderUserError'
      field?: Array<string> | null
      message: string
      code?: OrderErrorCode | null
    }>
  } | null
}

export type ProductFragment = {
  __typename?: 'Product'
  id: string
  status: ProductStatus
  approvalRequired: boolean
  baseTimeUnit?: number | null
  timeBased: boolean
  name: { __typename?: 'I18nString'; jaJp: string }
  description?: { __typename?: 'I18nString'; jaJp: string } | null
}

export type ProductVariantFragment = {
  __typename?: 'ProductVariant'
  id: string
  availableForSale: boolean
  price: number
  title: { __typename?: 'I18nString'; jaJp: string }
}

export type ProductImageFragment = {
  __typename?: 'Image'
  altText?: string | null
  filename: string
  id: string
  src: any
}

export type ProductsQueryVariables = Exact<{
  status?: InputMaybe<ProductStatus>
  name_Contains?: InputMaybe<Scalars['String']['input']>
  stores?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type ProductsQuery = {
  __typename?: 'QueryRoot'
  products?: {
    __typename?: 'ProductConnection'
    totalCount: number
    edges: Array<{
      __typename?: 'ProductEdge'
      product?: {
        __typename?: 'Product'
        id: string
        descriptionPlainText?: string | null
        status: ProductStatus
        approvalRequired: boolean
        timeBased: boolean
        createdAt: any
        updatedAt: any
        publishedAt?: any | null
        mapPosition?: {
          __typename?: 'MapPosition'
          lat: number
          lng: number
        } | null
        name: { __typename?: 'I18nString'; jaJp: string }
        description?: { __typename?: 'I18nString'; jaJp: string } | null
        images?: Array<{
          __typename?: 'Image'
          altText?: string | null
          filename: string
          id: string
          src: any
          key: string
          mimeType: string
        }> | null
        mapImage?: {
          __typename?: 'Image'
          altText?: string | null
          filename: string
          id: string
          src: any
          key: string
          mimeType: string
        } | null
        options?: Array<{
          __typename?: 'ProductOption'
          id: string
          position: number
          name?: { __typename?: 'I18nString'; jaJp: string } | null
          values?: Array<{
            __typename?: 'I18nString'
            jaJp: string
          } | null> | null
        } | null> | null
        variants?: {
          __typename?: 'ProductVariantConnection'
          totalCount: number
          edges: Array<{
            __typename?: 'ProductVariantEdge'
            variant?: {
              __typename?: 'ProductVariant'
              id: string
              availableForSale: boolean
              price: number
              compareAtPrice?: number | null
              excess?: number | null
              inventory?: number | null
              position: number
              specialPrice: number
              title: { __typename?: 'I18nString'; jaJp: string }
              periodForSale?: {
                __typename?: 'PeriodForSale'
                start?: any | null
                end?: any | null
              } | null
              selectedOptions?: Array<{
                __typename?: 'SelectedOption'
                id: string
                name: { __typename?: 'I18nString'; jaJp: string }
                value: { __typename?: 'I18nString'; jaJp: string }
              } | null> | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
  } | null
}

export type ProductQueryVariables = Exact<{
  id: Scalars['ID']['input']
  store?: InputMaybe<Scalars['String']['input']>
}>

export type ProductQuery = {
  __typename?: 'QueryRoot'
  product?: {
    __typename?: 'Product'
    id: string
    descriptionPlainText?: string | null
    status: ProductStatus
    approvalRequired: boolean
    baseTimeUnit?: number | null
    timeBased: boolean
    createdAt: any
    updatedAt: any
    publishedAt?: any | null
    name: { __typename?: 'I18nString'; jaJp: string }
    description?: { __typename?: 'I18nString'; jaJp: string } | null
    images?: Array<{
      __typename?: 'Image'
      altText?: string | null
      filename: string
      id: string
      src: any
      key: string
      mimeType: string
    }> | null
    mapImage?: {
      __typename?: 'Image'
      altText?: string | null
      filename: string
      id: string
      src: any
      key: string
      mimeType: string
    } | null
    options?: Array<{
      __typename?: 'ProductOption'
      id: string
      position: number
      name?: { __typename?: 'I18nString'; jaJp: string } | null
      values?: Array<{ __typename?: 'I18nString'; jaJp: string } | null> | null
    } | null> | null
    variants?: {
      __typename?: 'ProductVariantConnection'
      totalCount: number
      edges: Array<{
        __typename?: 'ProductVariantEdge'
        variant?: {
          __typename?: 'ProductVariant'
          id: string
          availableForSale: boolean
          price: number
          compareAtPrice?: number | null
          excess?: number | null
          inventory?: number | null
          position: number
          specialPrice: number
          title: { __typename?: 'I18nString'; jaJp: string }
          periodForSale?: {
            __typename?: 'PeriodForSale'
            start?: any | null
            end?: any | null
          } | null
          selectedOptions?: Array<{
            __typename?: 'SelectedOption'
            id: string
            name: { __typename?: 'I18nString'; jaJp: string }
            value: { __typename?: 'I18nString'; jaJp: string }
          } | null> | null
        } | null
      } | null>
    } | null
  } | null
}

export type AvailableProductsQueryVariables = Exact<{
  name_Contains?: InputMaybe<Scalars['String']['input']>
  store?: InputMaybe<Scalars['String']['input']>
  input?: InputMaybe<AvailableProductsInput>
  before?: InputMaybe<Scalars['String']['input']>
  after?: InputMaybe<Scalars['String']['input']>
  first?: InputMaybe<Scalars['Int']['input']>
  last?: InputMaybe<Scalars['Int']['input']>
}>

export type AvailableProductsQuery = {
  __typename?: 'QueryRoot'
  availableProducts?: {
    __typename?: 'ProductConnection'
    totalCount: number
    edges: Array<{
      __typename?: 'ProductEdge'
      product?: {
        __typename?: 'Product'
        id: string
        descriptionPlainText?: string | null
        status: ProductStatus
        approvalRequired: boolean
        baseTimeUnit?: number | null
        timeBased: boolean
        createdAt: any
        updatedAt: any
        publishedAt?: any | null
        mapPosition?: {
          __typename?: 'MapPosition'
          lat: number
          lng: number
        } | null
        name: { __typename?: 'I18nString'; jaJp: string }
        description?: { __typename?: 'I18nString'; jaJp: string } | null
        images?: Array<{
          __typename?: 'Image'
          altText?: string | null
          filename: string
          id: string
          src: any
          key: string
          mimeType: string
        }> | null
        mapImage?: {
          __typename?: 'Image'
          altText?: string | null
          filename: string
          id: string
          src: any
          key: string
          mimeType: string
        } | null
        options?: Array<{
          __typename?: 'ProductOption'
          id: string
          position: number
          name?: { __typename?: 'I18nString'; jaJp: string } | null
          values?: Array<{
            __typename?: 'I18nString'
            jaJp: string
          } | null> | null
        } | null> | null
        variants?: {
          __typename?: 'ProductVariantConnection'
          totalCount: number
          edges: Array<{
            __typename?: 'ProductVariantEdge'
            variant?: {
              __typename?: 'ProductVariant'
              id: string
              availableForSale: boolean
              price: number
              compareAtPrice?: number | null
              excess?: number | null
              inventory?: number | null
              position: number
              specialPrice: number
              title: { __typename?: 'I18nString'; jaJp: string }
              periodForSale?: {
                __typename?: 'PeriodForSale'
                start?: any | null
                end?: any | null
              } | null
              selectedOptions?: Array<{
                __typename?: 'SelectedOption'
                id: string
                name: { __typename?: 'I18nString'; jaJp: string }
                value: { __typename?: 'I18nString'; jaJp: string }
              } | null> | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
    pageInfo: {
      __typename?: 'PageInfo'
      hasNextPage: boolean
      hasPreviousPage: boolean
      startCursor?: string | null
      endCursor?: string | null
    }
  } | null
}

export type RateFragment = {
  __typename?: 'Rate'
  id: string
  status: RateStatus
  title: { __typename?: 'I18nString'; jaJp: string }
}

export type RateVariantFragment = {
  __typename?: 'RateVariant'
  id: string
  period?: {
    __typename?: 'Period'
    start?: any | null
    end?: any | null
  } | null
}

export type RatesQueryVariables = Exact<{
  stores?: InputMaybe<
    | Array<InputMaybe<Scalars['String']['input']>>
    | InputMaybe<Scalars['String']['input']>
  >
  status?: InputMaybe<RateStatus>
}>

export type RatesQuery = {
  __typename?: 'QueryRoot'
  rates?: {
    __typename?: 'RateConnection'
    totalCount: number
    edges: Array<{
      __typename?: 'RateEdge'
      rate?: {
        __typename?: 'Rate'
        id: string
        status: RateStatus
        createdAt: any
        updatedAt: any
        title: { __typename?: 'I18nString'; jaJp: string }
        description?: { __typename?: 'I18nString'; jaJp: string } | null
        variants?: {
          __typename?: 'RateVariantConnection'
          totalCount: number
          edges: Array<{
            __typename?: 'RateVariantEdge'
            variant?: {
              __typename?: 'RateVariant'
              id: string
              position?: number | null
              rate: number
              period?: {
                __typename?: 'Period'
                start?: any | null
                end?: any | null
              } | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
  } | null
}

export type NotForSalesQueryVariables = Exact<{ [key: string]: never }>

export type NotForSalesQuery = {
  __typename?: 'QueryRoot'
  notForSales?: {
    __typename?: 'NotForSaleConnection'
    edges: Array<{
      __typename?: 'NotForSaleEdge'
      node?: {
        __typename?: 'NotForSale'
        id: string
        rate?: {
          __typename?: 'Rate'
          id: string
          variants?: {
            __typename?: 'RateVariantConnection'
            edges: Array<{
              __typename?: 'RateVariantEdge'
              node?: {
                __typename?: 'RateVariant'
                id: string
                period?: {
                  __typename?: 'Period'
                  start?: any | null
                  end?: any | null
                } | null
              } | null
            } | null>
          } | null
        } | null
        products?: {
          __typename?: 'NotForSaleProductsConnection'
          edges: Array<{
            __typename?: 'NotForSaleProductsEdge'
            node?: {
              __typename?: 'NotForSaleProducts'
              variantIds?: Array<string | null> | null
              product?: {
                __typename?: 'Product'
                id: string
                name: { __typename?: 'I18nString'; jaJp: string }
              } | null
            } | null
          } | null>
        } | null
      } | null
    } | null>
  } | null
}

export const CustomerFragmentDoc = gql`
  fragment customer on Customer {
    address {
      address1
      address2
      city
      country
      prefecture
      prefectureCode
      zip
    }
    bookableFlag
    firstName
    email
    corporationName
    corporationNameKana
    lastName
    id
    isActive
    phone
    type
    appliedDiscount {
      discounts {
        edges {
          node {
            id
            description
            discountPercent {
              denominator
              numerator
              discountPercentLabel
            }
          }
        }
      }
    }
  }
`
export const CustomerMetaFragmentDoc = gql`
  fragment customerMeta on Customer {
    userMetaData {
      defaultLimit
      discount
      grantedAt
      limit
      timeFree
    }
  }
`
export const ProductFragmentDoc = gql`
  fragment product on Product {
    id
    name {
      jaJp
    }
    description {
      jaJp
    }
    status
    approvalRequired
    baseTimeUnit
    timeBased
  }
`
export const ProductVariantFragmentDoc = gql`
  fragment productVariant on ProductVariant {
    id
    title {
      jaJp
    }
    availableForSale
    price
  }
`
export const ProductImageFragmentDoc = gql`
  fragment productImage on Image {
    altText
    filename
    id
    src
  }
`
export const RateFragmentDoc = gql`
  fragment rate on Rate {
    id
    title {
      jaJp
    }
    status
  }
`
export const RateVariantFragmentDoc = gql`
  fragment rateVariant on RateVariant {
    id
    period {
      start
      end
    }
  }
`
export const BookingStatusOfTheDayForStorefrontDocument = gql`
  query BookingStatusOfTheDayForStorefront($input: BookingStatusOfTheDayInput) {
    bookingStatusOfTheDayForStorefront(input: $input) {
      date
      products {
        id
        name
        variants {
          id
          name
          availableForSale
          bookings
        }
      }
    }
  }
`

/**
 * __useBookingStatusOfTheDayForStorefrontQuery__
 *
 * To run a query within a React component, call `useBookingStatusOfTheDayForStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingStatusOfTheDayForStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingStatusOfTheDayForStorefrontQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBookingStatusOfTheDayForStorefrontQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >(BookingStatusOfTheDayForStorefrontDocument, options)
}
export function useBookingStatusOfTheDayForStorefrontLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >(BookingStatusOfTheDayForStorefrontDocument, options)
}
export function useBookingStatusOfTheDayForStorefrontSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BookingStatusOfTheDayForStorefrontQuery,
    BookingStatusOfTheDayForStorefrontQueryVariables
  >(BookingStatusOfTheDayForStorefrontDocument, options)
}
export type BookingStatusOfTheDayForStorefrontQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheDayForStorefrontQuery
>
export type BookingStatusOfTheDayForStorefrontLazyQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheDayForStorefrontLazyQuery
>
export type BookingStatusOfTheDayForStorefrontSuspenseQueryHookResult =
  ReturnType<typeof useBookingStatusOfTheDayForStorefrontSuspenseQuery>
export type BookingStatusOfTheDayForStorefrontQueryResult = Apollo.QueryResult<
  BookingStatusOfTheDayForStorefrontQuery,
  BookingStatusOfTheDayForStorefrontQueryVariables
>
export const BookingStatusOfTheMonthForStorefrontDocument = gql`
  query BookingStatusOfTheMonthForStorefront($date: Date) {
    bookingStatusOfTheMonthForStorefront(date: $date) {
      date
      products {
        id
        name
        variants {
          id
          name
          availableForSale
          bookingDates
        }
      }
    }
  }
`

/**
 * __useBookingStatusOfTheMonthForStorefrontQuery__
 *
 * To run a query within a React component, call `useBookingStatusOfTheMonthForStorefrontQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingStatusOfTheMonthForStorefrontQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingStatusOfTheMonthForStorefrontQuery({
 *   variables: {
 *      date: // value for 'date'
 *   },
 * });
 */
export function useBookingStatusOfTheMonthForStorefrontQuery(
  baseOptions?: Apollo.QueryHookOptions<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >(BookingStatusOfTheMonthForStorefrontDocument, options)
}
export function useBookingStatusOfTheMonthForStorefrontLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >(BookingStatusOfTheMonthForStorefrontDocument, options)
}
export function useBookingStatusOfTheMonthForStorefrontSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >(BookingStatusOfTheMonthForStorefrontDocument, options)
}
export type BookingStatusOfTheMonthForStorefrontQueryHookResult = ReturnType<
  typeof useBookingStatusOfTheMonthForStorefrontQuery
>
export type BookingStatusOfTheMonthForStorefrontLazyQueryHookResult =
  ReturnType<typeof useBookingStatusOfTheMonthForStorefrontLazyQuery>
export type BookingStatusOfTheMonthForStorefrontSuspenseQueryHookResult =
  ReturnType<typeof useBookingStatusOfTheMonthForStorefrontSuspenseQuery>
export type BookingStatusOfTheMonthForStorefrontQueryResult =
  Apollo.QueryResult<
    BookingStatusOfTheMonthForStorefrontQuery,
    BookingStatusOfTheMonthForStorefrontQueryVariables
  >
export const OrderForBookingListDocument = gql`
  query OrderForBookingList($id: ID!, $store: String) {
    orderForBookingList(id: $id, store: $store) {
      approval
      approvalRequired
      bookingDates {
        exceededTime
        date
        checkedOutAt
        checkedInAt
      }
      calendar {
        approval
        eventName
        organizer
        publishableDate
      }
      createdAt
      discountPrice
      entryFee
      id
      lineItems {
        edges {
          lineItem: node {
            id
            name {
              jaJp
            }
            price
            product {
              id
              name {
                jaJp
              }
              baseTimeUnit
              description {
                jaJp
              }
              status
              approvalRequired
              timeBased
              images {
                altText
                filename
                id
                src
                key
                mimeType
              }
              mapImage {
                altText
                filename
                id
                src
                key
                mimeType
              }
              options {
                id
                name {
                  jaJp
                }
                position
                values {
                  jaJp
                }
              }
              variants {
                edges {
                  cursor
                  variant: node {
                    id
                    title {
                      jaJp
                    }
                    unit
                    availableForSale
                    price
                    compareAtPrice
                    excess
                    inventory
                    position
                    selectedOptions {
                      id
                      name {
                        jaJp
                      }
                      value {
                        jaJp
                      }
                    }
                    specialPrice
                    periodForSale {
                      start
                      end
                    }
                  }
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                  startCursor
                  endCursor
                }
                totalCount
              }
              createdAt
              updatedAt
              publishedAt
            }
            arenaBookingInfo {
              dateOfUse
              quantity
            }
            quantity
            timeBased
            variant
            variantTitle {
              jaJp
            }
            specialPrice
          }
        }
      }
      numberOfPeople
      orderNumber
      originalSubTotalPrice
      originalSubTotalPriceTaxExcluded
      originalTotalPrice
      originalTotalTax
      payment {
        amount
        errorMessage
        processedAt
        refundablePeriod
        status
        updatedAt
      }
      period {
        start
        end
      }
      rate {
        parent {
          id
          status
          description {
            jaJp
          }
          variants {
            edges {
              variant: node {
                id
                period {
                  start
                  end
                }
                position
                rate
              }
            }
            totalCount
          }
        }
        rate
        title {
          jaJp
        }
        variantId
      }
      reasonForDisapproval
      refund {
        createdAt
        duties
        lineItemIds
        note
        status
        subTotalRefunded
        tax
        totalRefunded
        updatedAt
      }
      saleOfGoods
      serialNumber
      specialPriceIncluded
      status
      subTotalPrice
      subTotalPriceTaxExcluded
      totalPrice
      totalTax
      updatedAt
      canceledAt
      cancelReason
      purpose
      store
      storeOrderNumber
    }
  }
`

/**
 * __useOrderForBookingListQuery__
 *
 * To run a query within a React component, call `useOrderForBookingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderForBookingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderForBookingListQuery({
 *   variables: {
 *      id: // value for 'id'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useOrderForBookingListQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  > &
    (
      | { variables: OrderForBookingListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  >(OrderForBookingListDocument, options)
}
export function useOrderForBookingListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  >(OrderForBookingListDocument, options)
}
export function useOrderForBookingListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    OrderForBookingListQuery,
    OrderForBookingListQueryVariables
  >(OrderForBookingListDocument, options)
}
export type OrderForBookingListQueryHookResult = ReturnType<
  typeof useOrderForBookingListQuery
>
export type OrderForBookingListLazyQueryHookResult = ReturnType<
  typeof useOrderForBookingListLazyQuery
>
export type OrderForBookingListSuspenseQueryHookResult = ReturnType<
  typeof useOrderForBookingListSuspenseQuery
>
export type OrderForBookingListQueryResult = Apollo.QueryResult<
  OrderForBookingListQuery,
  OrderForBookingListQueryVariables
>
export const ContactFormSubmitDocument = gql`
  mutation contactFormSubmit($input: ContactFormInput!) {
    contactFormSubmit(input: $input) {
      contactForm {
        email
        message
        name
        queryType
        refNumber
        subject
      }
      contactFormUserErrors {
        field
        message
        code
      }
    }
  }
`
export type ContactFormSubmitMutationFn = Apollo.MutationFunction<
  ContactFormSubmitMutation,
  ContactFormSubmitMutationVariables
>

/**
 * __useContactFormSubmitMutation__
 *
 * To run a mutation, you first call `useContactFormSubmitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactFormSubmitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactFormSubmitMutation, { data, loading, error }] = useContactFormSubmitMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactFormSubmitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ContactFormSubmitMutation,
    ContactFormSubmitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ContactFormSubmitMutation,
    ContactFormSubmitMutationVariables
  >(ContactFormSubmitDocument, options)
}
export type ContactFormSubmitMutationHookResult = ReturnType<
  typeof useContactFormSubmitMutation
>
export type ContactFormSubmitMutationResult =
  Apollo.MutationResult<ContactFormSubmitMutation>
export type ContactFormSubmitMutationOptions = Apollo.BaseMutationOptions<
  ContactFormSubmitMutation,
  ContactFormSubmitMutationVariables
>
export const CustomerDocument = gql`
  query Customer {
    customer {
      address {
        address1
        address2
        city
        countryCode
        country
        prefecture
        prefectureCode
        zip
      }
      auth0Id
      appliedDiscount {
        discounts {
          edges {
            node {
              id
            }
          }
        }
      }
      bookableFlag
      email
      firstName
      fullname
      id
      lastName
      isActive
      note
      phone
      tags
      type
      corporationName
      userMetaData {
        defaultLimit
        discount
        grantedAt
        limit
        timeFree
      }
      createdAt
      updatedAt
      metaFields {
        edges {
          node {
            id
            key
          }
        }
      }
    }
  }
`

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *   },
 * });
 */
export function useCustomerQuery(
  baseOptions?: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  )
}
export function useCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerQuery,
    CustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  )
}
export function useCustomerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CustomerQuery,
    CustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options
  )
}
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>
export type CustomerLazyQueryHookResult = ReturnType<
  typeof useCustomerLazyQuery
>
export type CustomerSuspenseQueryHookResult = ReturnType<
  typeof useCustomerSuspenseQuery
>
export type CustomerQueryResult = Apollo.QueryResult<
  CustomerQuery,
  CustomerQueryVariables
>
export const CustomerUpdateDocument = gql`
  mutation customerUpdate(
    $input: CustomerUpdateInput!
    $updateAuth0User: Boolean
    $allowDuplicate: Boolean!
  ) {
    customerUpdate(
      input: $input
      updateAuth0User: $updateAuth0User
      allowDuplicate: $allowDuplicate
    ) {
      customer {
        id
      }
      customerUserErrors {
        field
        code
        message
      }
    }
  }
`
export type CustomerUpdateMutationFn = Apollo.MutationFunction<
  CustomerUpdateMutation,
  CustomerUpdateMutationVariables
>

/**
 * __useCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdateMutation, { data, loading, error }] = useCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      updateAuth0User: // value for 'updateAuth0User'
 *      allowDuplicate: // value for 'allowDuplicate'
 *   },
 * });
 */
export function useCustomerUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CustomerUpdateMutation,
    CustomerUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    CustomerUpdateMutation,
    CustomerUpdateMutationVariables
  >(CustomerUpdateDocument, options)
}
export type CustomerUpdateMutationHookResult = ReturnType<
  typeof useCustomerUpdateMutation
>
export type CustomerUpdateMutationResult =
  Apollo.MutationResult<CustomerUpdateMutation>
export type CustomerUpdateMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdateMutation,
  CustomerUpdateMutationVariables
>
export const NumberOfDiscountAppliedDocument = gql`
  query numberOfDiscountApplied($month: Date!) {
    numberOfDiscountApplied(month: $month) {
      numberOfSagaAqua
      numberOfSagaArena
      numberOfSagaPlaza
      numberOfSagaSta
    }
  }
`

/**
 * __useNumberOfDiscountAppliedQuery__
 *
 * To run a query within a React component, call `useNumberOfDiscountAppliedQuery` and pass it any options that fit your needs.
 * When your component renders, `useNumberOfDiscountAppliedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNumberOfDiscountAppliedQuery({
 *   variables: {
 *      month: // value for 'month'
 *   },
 * });
 */
export function useNumberOfDiscountAppliedQuery(
  baseOptions: Apollo.QueryHookOptions<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  > &
    (
      | { variables: NumberOfDiscountAppliedQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  >(NumberOfDiscountAppliedDocument, options)
}
export function useNumberOfDiscountAppliedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  >(NumberOfDiscountAppliedDocument, options)
}
export function useNumberOfDiscountAppliedSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    NumberOfDiscountAppliedQuery,
    NumberOfDiscountAppliedQueryVariables
  >(NumberOfDiscountAppliedDocument, options)
}
export type NumberOfDiscountAppliedQueryHookResult = ReturnType<
  typeof useNumberOfDiscountAppliedQuery
>
export type NumberOfDiscountAppliedLazyQueryHookResult = ReturnType<
  typeof useNumberOfDiscountAppliedLazyQuery
>
export type NumberOfDiscountAppliedSuspenseQueryHookResult = ReturnType<
  typeof useNumberOfDiscountAppliedSuspenseQuery
>
export type NumberOfDiscountAppliedQueryResult = Apollo.QueryResult<
  NumberOfDiscountAppliedQuery,
  NumberOfDiscountAppliedQueryVariables
>
export const HolidaysDocument = gql`
  query holidays(
    $store: String
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: ID
    $year: Int
  ) {
    holidays(
      store: $store
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      year: $year
    ) {
      totalCount
      edges {
        node {
          id
          year
          holidays {
            edges {
              node {
                date
                id
                isAutoGenerated
                isClose
                isPublic
                reason {
                  jaJp
                  enUs
                }
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useHolidaysQuery__
 *
 * To run a query within a React component, call `useHolidaysQuery` and pass it any options that fit your needs.
 * When your component renders, `useHolidaysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHolidaysQuery({
 *   variables: {
 *      store: // value for 'store'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      id: // value for 'id'
 *      year: // value for 'year'
 *   },
 * });
 */
export function useHolidaysQuery(
  baseOptions?: Apollo.QueryHookOptions<HolidaysQuery, HolidaysQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<HolidaysQuery, HolidaysQueryVariables>(
    HolidaysDocument,
    options
  )
}
export function useHolidaysLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    HolidaysQuery,
    HolidaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<HolidaysQuery, HolidaysQueryVariables>(
    HolidaysDocument,
    options
  )
}
export function useHolidaysSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HolidaysQuery,
    HolidaysQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<HolidaysQuery, HolidaysQueryVariables>(
    HolidaysDocument,
    options
  )
}
export type HolidaysQueryHookResult = ReturnType<typeof useHolidaysQuery>
export type HolidaysLazyQueryHookResult = ReturnType<
  typeof useHolidaysLazyQuery
>
export type HolidaysSuspenseQueryHookResult = ReturnType<
  typeof useHolidaysSuspenseQuery
>
export type HolidaysQueryResult = Apollo.QueryResult<
  HolidaysQuery,
  HolidaysQueryVariables
>
export const HolidayDocument = gql`
  query holiday($year: Int!, $store: String) {
    holiday(year: $year, store: $store) {
      id
      year
      holidays {
        edges {
          node {
            date
            id
            isClose
            isPublic
            isAutoGenerated
            reason {
              jaJp
              enUs
            }
          }
        }
      }
    }
  }
`

/**
 * __useHolidayQuery__
 *
 * To run a query within a React component, call `useHolidayQuery` and pass it any options that fit your needs.
 * When your component renders, `useHolidayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHolidayQuery({
 *   variables: {
 *      year: // value for 'year'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useHolidayQuery(
  baseOptions: Apollo.QueryHookOptions<HolidayQuery, HolidayQueryVariables> &
    ({ variables: HolidayQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<HolidayQuery, HolidayQueryVariables>(
    HolidayDocument,
    options
  )
}
export function useHolidayLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<HolidayQuery, HolidayQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<HolidayQuery, HolidayQueryVariables>(
    HolidayDocument,
    options
  )
}
export function useHolidaySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    HolidayQuery,
    HolidayQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<HolidayQuery, HolidayQueryVariables>(
    HolidayDocument,
    options
  )
}
export type HolidayQueryHookResult = ReturnType<typeof useHolidayQuery>
export type HolidayLazyQueryHookResult = ReturnType<typeof useHolidayLazyQuery>
export type HolidaySuspenseQueryHookResult = ReturnType<
  typeof useHolidaySuspenseQuery
>
export type HolidayQueryResult = Apollo.QueryResult<
  HolidayQuery,
  HolidayQueryVariables
>
export const BookingStatusListDocument = gql`
  query bookingStatusList($input: BookingStatusListInput!, $store: String) {
    bookingStatusList(input: $input, store: $store) {
      productId
      productName
      productVariants {
        id
        name
        availableForSale
        withinTheSalePeriod
        dataOfTheDays {
          name
          bookings
        }
      }
    }
  }
`

/**
 * __useBookingStatusListQuery__
 *
 * To run a query within a React component, call `useBookingStatusListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingStatusListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingStatusListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useBookingStatusListQuery(
  baseOptions: Apollo.QueryHookOptions<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  > &
    (
      | { variables: BookingStatusListQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  >(BookingStatusListDocument, options)
}
export function useBookingStatusListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  >(BookingStatusListDocument, options)
}
export function useBookingStatusListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    BookingStatusListQuery,
    BookingStatusListQueryVariables
  >(BookingStatusListDocument, options)
}
export type BookingStatusListQueryHookResult = ReturnType<
  typeof useBookingStatusListQuery
>
export type BookingStatusListLazyQueryHookResult = ReturnType<
  typeof useBookingStatusListLazyQuery
>
export type BookingStatusListSuspenseQueryHookResult = ReturnType<
  typeof useBookingStatusListSuspenseQuery
>
export type BookingStatusListQueryResult = Apollo.QueryResult<
  BookingStatusListQuery,
  BookingStatusListQueryVariables
>
export const StoreInformationDocument = gql`
  query storeInformation($store: String) {
    storeInformation(store: $store) {
      baseTimeUnit
      maxConsecutiveDays
      maxBookingsCount
      holidays {
        dates {
          date
        }
        daysOfWeek {
          name
          nth
        }
      }
    }
  }
`

/**
 * __useStoreInformationQuery__
 *
 * To run a query within a React component, call `useStoreInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useStoreInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStoreInformationQuery({
 *   variables: {
 *      store: // value for 'store'
 *   },
 * });
 */
export function useStoreInformationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    StoreInformationQuery,
    StoreInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<StoreInformationQuery, StoreInformationQueryVariables>(
    StoreInformationDocument,
    options
  )
}
export function useStoreInformationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    StoreInformationQuery,
    StoreInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    StoreInformationQuery,
    StoreInformationQueryVariables
  >(StoreInformationDocument, options)
}
export function useStoreInformationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    StoreInformationQuery,
    StoreInformationQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    StoreInformationQuery,
    StoreInformationQueryVariables
  >(StoreInformationDocument, options)
}
export type StoreInformationQueryHookResult = ReturnType<
  typeof useStoreInformationQuery
>
export type StoreInformationLazyQueryHookResult = ReturnType<
  typeof useStoreInformationLazyQuery
>
export type StoreInformationSuspenseQueryHookResult = ReturnType<
  typeof useStoreInformationSuspenseQuery
>
export type StoreInformationQueryResult = Apollo.QueryResult<
  StoreInformationQuery,
  StoreInformationQueryVariables
>
export const PriceCalculateDocument = gql`
  mutation priceCalculate($input: PriceCalculateInput!) {
    priceCalculate(input: $input) {
      price {
        originalSubTotalPrice
        originalSubTotalPriceTaxExcluded
        originalTotalTax
        originalTotalPrice
        subTotalPrice
        subTotalPriceTaxExcluded
        totalTax
        totalPrice
        specialPriceIncluded
        discountPrice
      }
    }
  }
`
export type PriceCalculateMutationFn = Apollo.MutationFunction<
  PriceCalculateMutation,
  PriceCalculateMutationVariables
>

/**
 * __usePriceCalculateMutation__
 *
 * To run a mutation, you first call `usePriceCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceCalculateMutation, { data, loading, error }] = usePriceCalculateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePriceCalculateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    PriceCalculateMutation,
    PriceCalculateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    PriceCalculateMutation,
    PriceCalculateMutationVariables
  >(PriceCalculateDocument, options)
}
export type PriceCalculateMutationHookResult = ReturnType<
  typeof usePriceCalculateMutation
>
export type PriceCalculateMutationResult =
  Apollo.MutationResult<PriceCalculateMutation>
export type PriceCalculateMutationOptions = Apollo.BaseMutationOptions<
  PriceCalculateMutation,
  PriceCalculateMutationVariables
>
export const ReportInvoiceExportDocument = gql`
  mutation ReportInvoiceExport($langCd: LanguageCode, $orderId: ID!) {
    reportInvoiceExport(langCd: $langCd, orderId: $orderId) {
      url
      userErrors {
        field
        message
      }
    }
  }
`
export type ReportInvoiceExportMutationFn = Apollo.MutationFunction<
  ReportInvoiceExportMutation,
  ReportInvoiceExportMutationVariables
>

/**
 * __useReportInvoiceExportMutation__
 *
 * To run a mutation, you first call `useReportInvoiceExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReportInvoiceExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reportInvoiceExportMutation, { data, loading, error }] = useReportInvoiceExportMutation({
 *   variables: {
 *      langCd: // value for 'langCd'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useReportInvoiceExportMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ReportInvoiceExportMutation,
    ReportInvoiceExportMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ReportInvoiceExportMutation,
    ReportInvoiceExportMutationVariables
  >(ReportInvoiceExportDocument, options)
}
export type ReportInvoiceExportMutationHookResult = ReturnType<
  typeof useReportInvoiceExportMutation
>
export type ReportInvoiceExportMutationResult =
  Apollo.MutationResult<ReportInvoiceExportMutation>
export type ReportInvoiceExportMutationOptions = Apollo.BaseMutationOptions<
  ReportInvoiceExportMutation,
  ReportInvoiceExportMutationVariables
>
export const GetBookingAvailabilitiesListDocument = gql`
  query getBookingAvailabilitiesList(
    $input: BookingAvailabilitiesListInput!
    $store: String
  ) {
    bookingAvailabilitiesList(input: $input, store: $store) {
      date
      availability
    }
  }
`

/**
 * __useGetBookingAvailabilitiesListQuery__
 *
 * To run a query within a React component, call `useGetBookingAvailabilitiesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBookingAvailabilitiesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBookingAvailabilitiesListQuery({
 *   variables: {
 *      input: // value for 'input'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useGetBookingAvailabilitiesListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  > &
    (
      | {
        variables: GetBookingAvailabilitiesListQueryVariables
        skip?: boolean
      }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  >(GetBookingAvailabilitiesListDocument, options)
}
export function useGetBookingAvailabilitiesListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  >(GetBookingAvailabilitiesListDocument, options)
}
export function useGetBookingAvailabilitiesListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    GetBookingAvailabilitiesListQuery,
    GetBookingAvailabilitiesListQueryVariables
  >(GetBookingAvailabilitiesListDocument, options)
}
export type GetBookingAvailabilitiesListQueryHookResult = ReturnType<
  typeof useGetBookingAvailabilitiesListQuery
>
export type GetBookingAvailabilitiesListLazyQueryHookResult = ReturnType<
  typeof useGetBookingAvailabilitiesListLazyQuery
>
export type GetBookingAvailabilitiesListSuspenseQueryHookResult = ReturnType<
  typeof useGetBookingAvailabilitiesListSuspenseQuery
>
export type GetBookingAvailabilitiesListQueryResult = Apollo.QueryResult<
  GetBookingAvailabilitiesListQuery,
  GetBookingAvailabilitiesListQueryVariables
>
export const UserVerificationEmailSendDocument = gql`
  mutation userVerificationEmailSend($input: UserVerificationEmailSendInput!) {
    userVerificationEmailSend(input: $input) {
      userVerificationEmailSendResult {
        jobId
        jobType
        jobStatus
      }
      userVerificationEmailSendErrors {
        field
        message
        code
      }
    }
  }
`
export type UserVerificationEmailSendMutationFn = Apollo.MutationFunction<
  UserVerificationEmailSendMutation,
  UserVerificationEmailSendMutationVariables
>

/**
 * __useUserVerificationEmailSendMutation__
 *
 * To run a mutation, you first call `useUserVerificationEmailSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserVerificationEmailSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userVerificationEmailSendMutation, { data, loading, error }] = useUserVerificationEmailSendMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUserVerificationEmailSendMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UserVerificationEmailSendMutation,
    UserVerificationEmailSendMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    UserVerificationEmailSendMutation,
    UserVerificationEmailSendMutationVariables
  >(UserVerificationEmailSendDocument, options)
}
export type UserVerificationEmailSendMutationHookResult = ReturnType<
  typeof useUserVerificationEmailSendMutation
>
export type UserVerificationEmailSendMutationResult =
  Apollo.MutationResult<UserVerificationEmailSendMutation>
export type UserVerificationEmailSendMutationOptions =
  Apollo.BaseMutationOptions<
    UserVerificationEmailSendMutation,
    UserVerificationEmailSendMutationVariables
  >
export const OrdersDocument = gql`
  query Orders(
    $approval: OrderApproval
    $bookingDates: Date
    $bookingDates_Lt: Date
    $bookingDates_Lte: Date
    $bookingDates_Gt: Date
    $bookingDates_Gte: Date
    $createdAt_Lte: DateTime
    $createdAt_Gte: DateTime
    $orderNumber: Int
    $productName: String
    $productName_Startswith: String
    $productName_Endswith: String
    $productName_Contains: String
    $before: String
    $after: String
    $first: Int
    $last: Int
    $sort: SortInput
    $stores: [String]
  ) {
    orders(
      approval: $approval
      bookingDates: $bookingDates
      bookingDates_Lt: $bookingDates_Lt
      bookingDates_Lte: $bookingDates_Lte
      bookingDates_Gt: $bookingDates_Gt
      bookingDates_Gte: $bookingDates_Gte
      createdAt_Lte: $createdAt_Lte
      createdAt_Gte: $createdAt_Gte
      orderNumber: $orderNumber
      productName: $productName
      productName_Startswith: $productName_Startswith
      productName_Endswith: $productName_Endswith
      productName_Contains: $productName_Contains
      before: $before
      after: $after
      first: $first
      last: $last
      sort: $sort
      stores: $stores
    ) {
      edges {
        order: node {
          approval
          approvalRequired
          bookingDates {
            exceededTime
            date
            checkedOutAt
            checkedInAt
          }
          calendar {
            approval
            eventName
            organizer
            publishableDate
          }
          contactOfRepresentative {
            email
            name
            phone
          }
          createdAt
          customer {
            ...customer
            ...customerMeta
            auth0Id
            firstName
            fullname
            lastName
          }
          entryFee
          id
          lineItems {
            edges {
              lineItem: node {
                id
                name {
                  jaJp
                }
                arenaBookingInfo {
                  dateOfUse
                  quantity
                }
                price
                product {
                  id
                  name {
                    jaJp
                  }
                  baseTimeUnit
                  description {
                    jaJp
                  }
                  status
                  approvalRequired
                  timeBased
                  images {
                    altText
                    filename
                    id
                    src
                    key
                    mimeType
                  }
                  mapImage {
                    altText
                    filename
                    id
                    src
                    key
                    mimeType
                  }
                  options {
                    id
                    name {
                      jaJp
                    }
                    position
                    values {
                      jaJp
                    }
                  }
                  variants {
                    edges {
                      cursor
                      variant: node {
                        id
                        title {
                          jaJp
                        }
                        availableForSale
                        price
                        compareAtPrice
                        excess
                        inventory
                        position
                        selectedOptions {
                          id
                          name {
                            jaJp
                          }
                          value {
                            jaJp
                          }
                        }
                        specialPrice
                        periodForSale {
                          start
                          end
                        }
                      }
                    }
                    pageInfo {
                      hasNextPage
                      hasPreviousPage
                      startCursor
                      endCursor
                    }
                    totalCount
                  }
                  createdAt
                  updatedAt
                  publishedAt
                }
                quantity
                timeBased
                variant
                variantTitle {
                  jaJp
                }
                specialPrice
              }
            }
          }
          status
          numberOfPeople
          orderNumber
          originalSubTotalPrice
          originalTotalPrice
          originalTotalTax
          payment {
            amount
            errorMessage
            processedAt
            refundablePeriod
            status
            updatedAt
          }
          period {
            start
            end
          }
          reasonForDisapproval
          saleOfGoods
          serialNumber
          specialPriceIncluded
          subTotalPrice
          totalPrice
          totalTax
          updatedAt
          canceledAt
          store
          storeOrderNumber
        }
        cursor
      }
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
  ${CustomerFragmentDoc}
  ${CustomerMetaFragmentDoc}
`

/**
 * __useOrdersQuery__
 *
 * To run a query within a React component, call `useOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQuery({
 *   variables: {
 *      approval: // value for 'approval'
 *      bookingDates: // value for 'bookingDates'
 *      bookingDates_Lt: // value for 'bookingDates_Lt'
 *      bookingDates_Lte: // value for 'bookingDates_Lte'
 *      bookingDates_Gt: // value for 'bookingDates_Gt'
 *      bookingDates_Gte: // value for 'bookingDates_Gte'
 *      createdAt_Lte: // value for 'createdAt_Lte'
 *      createdAt_Gte: // value for 'createdAt_Gte'
 *      orderNumber: // value for 'orderNumber'
 *      productName: // value for 'productName'
 *      productName_Startswith: // value for 'productName_Startswith'
 *      productName_Endswith: // value for 'productName_Endswith'
 *      productName_Contains: // value for 'productName_Contains'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      sort: // value for 'sort'
 *      stores: // value for 'stores'
 *   },
 * });
 */
export function useOrdersQuery(
  baseOptions?: Apollo.QueryHookOptions<OrdersQuery, OrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrdersQuery, OrdersQueryVariables>(
    OrdersDocument,
    options
  )
}
export function useOrdersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrdersQuery, OrdersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrdersQuery, OrdersQueryVariables>(
    OrdersDocument,
    options
  )
}
export function useOrdersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrdersQuery,
    OrdersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OrdersQuery, OrdersQueryVariables>(
    OrdersDocument,
    options
  )
}
export type OrdersQueryHookResult = ReturnType<typeof useOrdersQuery>
export type OrdersLazyQueryHookResult = ReturnType<typeof useOrdersLazyQuery>
export type OrdersSuspenseQueryHookResult = ReturnType<
  typeof useOrdersSuspenseQuery
>
export type OrdersQueryResult = Apollo.QueryResult<
  OrdersQuery,
  OrdersQueryVariables
>
export const OrderDocument = gql`
  query order($id: ID!, $store: String) {
    order(id: $id, store: $store) {
      approval
      approvalRequired
      bookingDates {
        exceededTime
        date
        checkedOutAt
        checkedInAt
      }
      calendar {
        approval
        eventName
        organizer
        publishableDate
      }
      contactOfRepresentative {
        email
        name
        phone
      }
      createdAt
      customer {
        ...customer
        ...customerMeta
        auth0Id
        firstName
        fullname
        lastName
      }
      discountPrice
      entryFee
      id
      lineItems {
        edges {
          lineItem: node {
            id
            name {
              jaJp
            }
            price
            product {
              id
              name {
                jaJp
              }
              baseTimeUnit
              description {
                jaJp
              }
              status
              approvalRequired
              timeBased
              images {
                altText
                filename
                id
                src
                key
                mimeType
              }
              mapImage {
                altText
                filename
                id
                src
                key
                mimeType
              }
              options {
                id
                name {
                  jaJp
                }
                position
                values {
                  jaJp
                }
              }
              variants {
                edges {
                  cursor
                  variant: node {
                    id
                    title {
                      jaJp
                    }
                    unit
                    availableForSale
                    price
                    compareAtPrice
                    excess
                    inventory
                    position
                    selectedOptions {
                      id
                      name {
                        jaJp
                      }
                      value {
                        jaJp
                      }
                    }
                    specialPrice
                    periodForSale {
                      start
                      end
                    }
                  }
                }
                pageInfo {
                  hasNextPage
                  hasPreviousPage
                  startCursor
                  endCursor
                }
                totalCount
              }
              createdAt
              updatedAt
              publishedAt
            }
            arenaBookingInfo {
              dateOfUse
              quantity
            }
            quantity
            timeBased
            variant
            variantTitle {
              jaJp
            }
            specialPrice
          }
        }
      }
      numberOfPeople
      orderNumber
      originalSubTotalPrice
      originalSubTotalPriceTaxExcluded
      originalTotalPrice
      originalTotalTax
      payment {
        amount
        errorMessage
        processedAt
        refundablePeriod
        status
        updatedAt
      }
      period {
        start
        end
      }
      rate {
        parent {
          id
          status
          description {
            jaJp
          }
          variants {
            edges {
              variant: node {
                id
                period {
                  start
                  end
                }
                position
                rate
              }
            }
            totalCount
          }
        }
        rate
        title {
          jaJp
        }
        variantId
      }
      reasonForDisapproval
      refund {
        createdAt
        duties
        lineItemIds
        note
        status
        subTotalRefunded
        tax
        totalRefunded
        updatedAt
      }
      saleOfGoods
      serialNumber
      specialPriceIncluded
      status
      subTotalPrice
      subTotalPriceTaxExcluded
      totalPrice
      totalTax
      updatedAt
      canceledAt
      cancelReason
      purpose
      store
      storeOrderNumber
    }
  }
  ${CustomerFragmentDoc}
  ${CustomerMetaFragmentDoc}
`

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useOrderQuery(
  baseOptions: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables> &
    ({ variables: OrderQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export function useOrderLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export function useOrderSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<OrderQuery, OrderQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<OrderQuery, OrderQueryVariables>(
    OrderDocument,
    options
  )
}
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>
export type OrderSuspenseQueryHookResult = ReturnType<
  typeof useOrderSuspenseQuery
>
export type OrderQueryResult = Apollo.QueryResult<
  OrderQuery,
  OrderQueryVariables
>
export const OrderUpdateDocument = gql`
  mutation orderUpdate($id: ID!, $input: OrderUpdateInput!, $store: String) {
    orderUpdate(id: $id, input: $input, store: $store) {
      order {
        id
      }
      orderUserErrors {
        field
        message
        code
      }
    }
  }
`
export type OrderUpdateMutationFn = Apollo.MutationFunction<
  OrderUpdateMutation,
  OrderUpdateMutationVariables
>

/**
 * __useOrderUpdateMutation__
 *
 * To run a mutation, you first call `useOrderUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderUpdateMutation, { data, loading, error }] = useOrderUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useOrderUpdateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderUpdateMutation,
    OrderUpdateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OrderUpdateMutation, OrderUpdateMutationVariables>(
    OrderUpdateDocument,
    options
  )
}
export type OrderUpdateMutationHookResult = ReturnType<
  typeof useOrderUpdateMutation
>
export type OrderUpdateMutationResult =
  Apollo.MutationResult<OrderUpdateMutation>
export type OrderUpdateMutationOptions = Apollo.BaseMutationOptions<
  OrderUpdateMutation,
  OrderUpdateMutationVariables
>
export const OrderCreateDocument = gql`
  mutation orderCreate($input: OrderCreateInput!, $store: String) {
    orderCreate(input: $input, store: $store) {
      order {
        id
        discountPrice
        serialNumber
        originalSubTotalPrice
        originalTotalPrice
        originalTotalTax
        totalTax
        serialNumber
        specialPriceIncluded
        calendar {
          approval
          organizer
          eventName
          publishableDate
        }
      }
      orderUserErrors {
        field
        message
        code
      }
    }
  }
`
export type OrderCreateMutationFn = Apollo.MutationFunction<
  OrderCreateMutation,
  OrderCreateMutationVariables
>

/**
 * __useOrderCreateMutation__
 *
 * To run a mutation, you first call `useOrderCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCreateMutation, { data, loading, error }] = useOrderCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useOrderCreateMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderCreateMutation,
    OrderCreateMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OrderCreateMutation, OrderCreateMutationVariables>(
    OrderCreateDocument,
    options
  )
}
export type OrderCreateMutationHookResult = ReturnType<
  typeof useOrderCreateMutation
>
export type OrderCreateMutationResult =
  Apollo.MutationResult<OrderCreateMutation>
export type OrderCreateMutationOptions = Apollo.BaseMutationOptions<
  OrderCreateMutation,
  OrderCreateMutationVariables
>
export const OrderCancelDocument = gql`
  mutation orderCancel(
    $id: ID!
    $cancelReason: OrderCancelReason
    $store: String
  ) {
    orderCancel(id: $id, cancelReason: $cancelReason, store: $store) {
      order {
        id
      }
      orderUserErrors {
        field
        message
        code
      }
    }
  }
`
export type OrderCancelMutationFn = Apollo.MutationFunction<
  OrderCancelMutation,
  OrderCancelMutationVariables
>

/**
 * __useOrderCancelMutation__
 *
 * To run a mutation, you first call `useOrderCancelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderCancelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderCancelMutation, { data, loading, error }] = useOrderCancelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      cancelReason: // value for 'cancelReason'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useOrderCancelMutation(
  baseOptions?: Apollo.MutationHookOptions<
    OrderCancelMutation,
    OrderCancelMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<OrderCancelMutation, OrderCancelMutationVariables>(
    OrderCancelDocument,
    options
  )
}
export type OrderCancelMutationHookResult = ReturnType<
  typeof useOrderCancelMutation
>
export type OrderCancelMutationResult =
  Apollo.MutationResult<OrderCancelMutation>
export type OrderCancelMutationOptions = Apollo.BaseMutationOptions<
  OrderCancelMutation,
  OrderCancelMutationVariables
>
export const ProductsDocument = gql`
  query products(
    $status: ProductStatus
    $name_Contains: String
    $stores: [String]
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    products(
      status: $status
      name_Contains: $name_Contains
      stores: $stores
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        product: node {
          id
          mapPosition {
            lat
            lng
          }
          name {
            jaJp
          }
          description {
            jaJp
          }
          descriptionPlainText
          status
          approvalRequired
          timeBased
          images {
            altText
            filename
            id
            src
            key
            mimeType
          }
          mapImage {
            altText
            filename
            id
            src
            key
            mimeType
          }
          options {
            id
            name {
              jaJp
            }
            position
            values {
              jaJp
            }
          }
          variants {
            edges {
              variant: node {
                id
                title {
                  jaJp
                }
                availableForSale
                price
                compareAtPrice
                excess
                inventory
                position
                specialPrice
                periodForSale {
                  start
                  end
                }
                selectedOptions {
                  id
                  name {
                    jaJp
                  }
                  value {
                    jaJp
                  }
                }
              }
            }
            totalCount
          }
          createdAt
          updatedAt
          publishedAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`

/**
 * __useProductsQuery__
 *
 * To run a query within a React component, call `useProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      name_Contains: // value for 'name_Contains'
 *      stores: // value for 'stores'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<ProductsQuery, ProductsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductsQuery, ProductsQueryVariables>(
    ProductsDocument,
    options
  )
}
export function useProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ProductsQuery,
    ProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductsQuery, ProductsQueryVariables>(
    ProductsDocument,
    options
  )
}
export function useProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductsQuery,
    ProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductsQuery, ProductsQueryVariables>(
    ProductsDocument,
    options
  )
}
export type ProductsQueryHookResult = ReturnType<typeof useProductsQuery>
export type ProductsLazyQueryHookResult = ReturnType<
  typeof useProductsLazyQuery
>
export type ProductsSuspenseQueryHookResult = ReturnType<
  typeof useProductsSuspenseQuery
>
export type ProductsQueryResult = Apollo.QueryResult<
  ProductsQuery,
  ProductsQueryVariables
>
export const ProductDocument = gql`
  query product($id: ID!, $store: String) {
    product(id: $id, store: $store) {
      id
      name {
        jaJp
      }
      description {
        jaJp
      }
      descriptionPlainText
      status
      approvalRequired
      baseTimeUnit
      timeBased
      images {
        altText
        filename
        id
        src
        key
        mimeType
      }
      mapImage {
        altText
        filename
        id
        src
        key
        mimeType
      }
      options {
        id
        name {
          jaJp
        }
        position
        values {
          jaJp
        }
      }
      variants {
        edges {
          variant: node {
            id
            title {
              jaJp
            }
            availableForSale
            price
            compareAtPrice
            excess
            inventory
            position
            specialPrice
            periodForSale {
              start
              end
            }
            selectedOptions {
              id
              name {
                jaJp
              }
              value {
                jaJp
              }
            }
            specialPrice
          }
        }
        totalCount
      }
      createdAt
      updatedAt
      publishedAt
    }
  }
`

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      id: // value for 'id'
 *      store: // value for 'store'
 *   },
 * });
 */
export function useProductQuery(
  baseOptions: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables> &
    ({ variables: ProductQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<ProductQuery, ProductQueryVariables>(
    ProductDocument,
    options
  )
}
export function useProductLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(
    ProductDocument,
    options
  )
}
export function useProductSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    ProductQuery,
    ProductQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<ProductQuery, ProductQueryVariables>(
    ProductDocument,
    options
  )
}
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>
export type ProductSuspenseQueryHookResult = ReturnType<
  typeof useProductSuspenseQuery
>
export type ProductQueryResult = Apollo.QueryResult<
  ProductQuery,
  ProductQueryVariables
>
export const AvailableProductsDocument = gql`
  query AvailableProducts(
    $name_Contains: String
    $store: String
    $input: AvailableProductsInput
    $before: String
    $after: String
    $first: Int
    $last: Int
  ) {
    availableProducts(
      name_Contains: $name_Contains
      store: $store
      input: $input
      before: $before
      after: $after
      first: $first
      last: $last
    ) {
      edges {
        product: node {
          id
          mapPosition {
            lat
            lng
          }
          name {
            jaJp
          }
          description {
            jaJp
          }
          descriptionPlainText
          status
          approvalRequired
          baseTimeUnit
          timeBased
          images {
            altText
            filename
            id
            src
            key
            mimeType
          }
          mapImage {
            altText
            filename
            id
            src
            key
            mimeType
          }
          options {
            id
            name {
              jaJp
            }
            position
            values {
              jaJp
            }
          }
          variants {
            edges {
              variant: node {
                id
                title {
                  jaJp
                }
                availableForSale
                price
                compareAtPrice
                excess
                inventory
                position
                specialPrice
                periodForSale {
                  start
                  end
                }
                selectedOptions {
                  id
                  name {
                    jaJp
                  }
                  value {
                    jaJp
                  }
                }
              }
            }
            totalCount
          }
          createdAt
          updatedAt
          publishedAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`

/**
 * __useAvailableProductsQuery__
 *
 * To run a query within a React component, call `useAvailableProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableProductsQuery({
 *   variables: {
 *      name_Contains: // value for 'name_Contains'
 *      store: // value for 'store'
 *      input: // value for 'input'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useAvailableProductsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >(AvailableProductsDocument, options)
}
export function useAvailableProductsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >(AvailableProductsDocument, options)
}
export function useAvailableProductsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AvailableProductsQuery,
    AvailableProductsQueryVariables
  >(AvailableProductsDocument, options)
}
export type AvailableProductsQueryHookResult = ReturnType<
  typeof useAvailableProductsQuery
>
export type AvailableProductsLazyQueryHookResult = ReturnType<
  typeof useAvailableProductsLazyQuery
>
export type AvailableProductsSuspenseQueryHookResult = ReturnType<
  typeof useAvailableProductsSuspenseQuery
>
export type AvailableProductsQueryResult = Apollo.QueryResult<
  AvailableProductsQuery,
  AvailableProductsQueryVariables
>
export const RatesDocument = gql`
  query rates($stores: [String], $status: RateStatus) {
    rates(stores: $stores, status: $status) {
      edges {
        rate: node {
          id
          title {
            jaJp
          }
          status
          description {
            jaJp
          }
          variants {
            edges {
              variant: node {
                id
                period {
                  start
                  end
                }
                position
                rate
              }
            }
            totalCount
          }
          createdAt
          updatedAt
        }
      }
      totalCount
    }
  }
`

/**
 * __useRatesQuery__
 *
 * To run a query within a React component, call `useRatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatesQuery({
 *   variables: {
 *      stores: // value for 'stores'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useRatesQuery(
  baseOptions?: Apollo.QueryHookOptions<RatesQuery, RatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<RatesQuery, RatesQueryVariables>(
    RatesDocument,
    options
  )
}
export function useRatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<RatesQuery, RatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<RatesQuery, RatesQueryVariables>(
    RatesDocument,
    options
  )
}
export function useRatesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<RatesQuery, RatesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<RatesQuery, RatesQueryVariables>(
    RatesDocument,
    options
  )
}
export type RatesQueryHookResult = ReturnType<typeof useRatesQuery>
export type RatesLazyQueryHookResult = ReturnType<typeof useRatesLazyQuery>
export type RatesSuspenseQueryHookResult = ReturnType<
  typeof useRatesSuspenseQuery
>
export type RatesQueryResult = Apollo.QueryResult<
  RatesQuery,
  RatesQueryVariables
>
export const NotForSalesDocument = gql`
  query notForSales {
    notForSales {
      edges {
        node {
          id
          rate {
            id
            variants {
              edges {
                node {
                  id
                  period {
                    start
                    end
                  }
                }
              }
            }
          }
          products {
            edges {
              node {
                product {
                  id
                  name {
                    jaJp
                  }
                }
                variantIds
              }
            }
          }
        }
      }
    }
  }
`

/**
 * __useNotForSalesQuery__
 *
 * To run a query within a React component, call `useNotForSalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotForSalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotForSalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotForSalesQuery(
  baseOptions?: Apollo.QueryHookOptions<
    NotForSalesQuery,
    NotForSalesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<NotForSalesQuery, NotForSalesQueryVariables>(
    NotForSalesDocument,
    options
  )
}
export function useNotForSalesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    NotForSalesQuery,
    NotForSalesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<NotForSalesQuery, NotForSalesQueryVariables>(
    NotForSalesDocument,
    options
  )
}
export function useNotForSalesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    NotForSalesQuery,
    NotForSalesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<NotForSalesQuery, NotForSalesQueryVariables>(
    NotForSalesDocument,
    options
  )
}
export type NotForSalesQueryHookResult = ReturnType<typeof useNotForSalesQuery>
export type NotForSalesLazyQueryHookResult = ReturnType<
  typeof useNotForSalesLazyQuery
>
export type NotForSalesSuspenseQueryHookResult = ReturnType<
  typeof useNotForSalesSuspenseQuery
>
export type NotForSalesQueryResult = Apollo.QueryResult<
  NotForSalesQuery,
  NotForSalesQueryVariables
>
